

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import * as XLSX from "xlsx";
// import { URL } from "../config";
// import crmLogo from "../assets/crmimg.png";
// import { useNavigate } from "react-router-dom";

// const API_URL        = `${URL}/followup-masters`;
// const EMP_API_URL    = `${URL}/employee-masters`;
// const BUDGET_API_URL = `${URL}/budget-masters`;
// const AREA_API_URL   = `${URL}/area-masters`;

// if (typeof document !== "undefined" && !document.getElementById("poppins-font")) {
//   const link = document.createElement("link");
//   link.id   = "poppins-font";
//   link.rel  = "stylesheet";
//   link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap";
//   document.head.appendChild(link);
// }

// const BR = "#1D4ED8";

// const AVATAR_COLORS = [
//   "#1D4ED8","#7C3AED","#DB2777","#D97706","#059669",
//   "#DC2626","#2563EB","#9333EA","#EA580C","#0891B2",
// ];



// const getAvatarColor = (name) => {
//   if (!name) return AVATAR_COLORS[0];
//   let hash = 0;
//   for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
//   return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
// };
// const getInitials = (name) => {
//   if (!name) return "?";
//   const parts = String(name).trim().split(/\s+/);
//   if (parts.length === 1) return parts[0][0].toUpperCase();
//   return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
// };

// const STATUS_CONFIG = {
//   "followup":      { bg: "#FEF9C3", color: "#854D0E", label: "Follow Up",     dot: "#D97706" },
//   "success close": { bg: "#DCFCE7", color: "#166534", label: "Success Close", dot: "#16A34A" },
//   "cancel":        { bg: "#FEE2E2", color: "#991B1B", label: "Cancel",        dot: "#DC2626" },
// };
// const getStatusCfg = (name) => {
//   if (!name) return { bg: "#F5F3FF", color: "#6D28D9", label: "New", dot: "#7C3AED" };
//   const n = name.toLowerCase();
//   if (n.includes("follow"))  return STATUS_CONFIG["followup"];
//   if (n.includes("success")) return STATUS_CONFIG["success close"];
//   if (n.includes("cancel"))  return STATUS_CONFIG["cancel"];
//   return { bg: "#F5F3FF", color: "#6D28D9", label: name, dot: "#7C3AED" };
// };

// const PRIORITY_CONFIG = {
//   high:   { bg: "#FEE2E2", color: "#991B1B", label: "High",   dash: false },
//   medium: { bg: "#FEF9C3", color: "#854D0E", label: "Medium", dash: true  },
//   low:    { bg: "#DCFCE7", color: "#166534", label: "Low",    dash: false },
// };
// const getPriorityCfg = (name) => {
//   if (!name) return { bg: "#F1F5F9", color: "#64748B", label: "—", dash: true };
//   const n = name.toLowerCase();
//   if (n.includes("high"))   return PRIORITY_CONFIG["high"];
//   if (n.includes("medium")) return PRIORITY_CONFIG["medium"];
//   if (n.includes("low"))    return PRIORITY_CONFIG["low"];
//   return { bg: "#F1F5F9", color: "#64748B", label: name, dash: false };
// };

// function Avatar({ name, size = 32 }) {
//   return (
//     <span style={{
//       display: "inline-flex", alignItems: "center", justifyContent: "center",
//       width: size, height: size, borderRadius: "50%",
//       background: getAvatarColor(name), color: "#fff",
//       fontSize: size * 0.38, fontWeight: 700, flexShrink: 0, lineHeight: 1,
//       fontFamily: "'Poppins', sans-serif",
//     }}>
//       {getInitials(name)}
//     </span>
//   );
// }

// function StatusBadge({ statusName }) {
//   const cfg = getStatusCfg(statusName);
//   return (
//     <span style={{
//       background: cfg.bg, color: cfg.color,
//       padding: "3px 10px", borderRadius: 20, fontSize: 11.5,
//       fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 5,
//       fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap",
//     }}>
//       <span style={{ width: 7, height: 7, borderRadius: "50%", background: cfg.dot, flexShrink: 0 }} />
//       {cfg.label}
//     </span>
//   );
// }

// function PriorityBadge({ priorityName }) {
//   const cfg = getPriorityCfg(priorityName);
//   return (
//     <span style={{
//       background: cfg.bg, color: cfg.color,
//       padding: "3px 10px", borderRadius: 20, fontSize: 11.5,
//       fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 5,
//       fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap",
//     }}>
//       {cfg.dash && <span style={{ fontWeight: 900, fontSize: 13, lineHeight: 1 }}>—</span>}
//       {cfg.label}
//     </span>
//   );
// }

// function Skeleton({ width = "100%", height = 16, radius = 6 }) {
//   return (
//     <div style={{
//       width, height, borderRadius: radius,
//       background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
//       backgroundSize: "200% 100%",
//       animation: "shimmer 1.4s infinite",
//     }} />
//   );
// }



// // ── Area Multi-Select Dropdown ─────────────────────────────────────────────
// function AreaMultiSelect({ areas, selectedIds, onChange }) {
//   const [open, setOpen]     = useState(false);
//   const [search, setSearch] = useState("");
//   const ref                 = useRef(null);

//   useEffect(() => {
//     const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   const filteredAreas = areas.filter(a =>
//     (a.areaName || "").toLowerCase().includes(search.toLowerCase())
//   );

//   const toggle = (id) => {
//     onChange(selectedIds.includes(id)
//       ? selectedIds.filter(x => x !== id)
//       : [...selectedIds, id]
//     );
//   };

//   const isActive = selectedIds.length > 0;
//   const label = !isActive
//     ? "All Areas"
//     : selectedIds.length === 1
//       ? (areas.find(a => a.areaId === selectedIds[0])?.areaName || "1 selected")
//       : `${selectedIds.length} areas selected`;

//   return (
//     <div ref={ref} style={{ position: "relative", display: "flex", flexDirection: "column", gap: 4 }}>
//       <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Area</label>
//       <button
//         onClick={() => setOpen(o => !o)}
//         style={{
//           height: 42, padding: "0 36px 0 14px", borderRadius: 8,
//           border: `1.5px solid ${isActive ? BR : "#E2E8F0"}`,
//           background: "#fff", cursor: "pointer", fontSize: 13.5,
//           fontFamily: "'Poppins', sans-serif",
//           color: isActive ? BR : "#1E293B", fontWeight: isActive ? 700 : 500,
//           textAlign: "left", minWidth: 180,
//           backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
//           backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
//           whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
//         }}
//       >
//         {label}
//       </button>

//       {open && (
//         <div style={{
//           position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 1000,
//           background: "#fff", borderRadius: 10,
//           border: "1.5px solid #E2E8F0", minWidth: 230,
//           boxShadow: "0 8px 24px rgba(0,0,0,.13)", overflow: "hidden",
//         }}>
//           <div style={{ padding: "8px 10px", borderBottom: "1px solid #F1F5F9" }}>
//             <input
//               autoFocus
//               type="text"
//               placeholder="Search area..."
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//               style={{
//                 width: "100%", height: 32, border: "1.5px solid #E2E8F0",
//                 borderRadius: 6, padding: "0 8px", fontSize: 12.5,
//                 fontFamily: "'Poppins', sans-serif", outline: "none",
//                 boxSizing: "border-box", color: "#1E293B",
//               }}
//             />
//           </div>
//           <div style={{ padding: "6px 12px", borderBottom: "1px solid #F1F5F9", display: "flex", gap: 10 }}>
//             <button onClick={() => onChange(areas.map(a => a.areaId))} style={{ fontSize: 11.5, fontWeight: 700, color: BR, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "'Poppins', sans-serif" }}>Select All</button>
//             <span style={{ color: "#E2E8F0", alignSelf: "center" }}>|</span>
//             <button onClick={() => onChange([])} style={{ fontSize: 11.5, fontWeight: 700, color: "#991B1B", background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "'Poppins', sans-serif" }}>Clear</button>
//           </div>
//           <div style={{ maxHeight: 220, overflowY: "auto" }}>
//             {filteredAreas.length === 0 ? (
//               <div style={{ padding: "14px", fontSize: 12, color: "#94A3B8", textAlign: "center" }}>No areas found</div>
//             ) : filteredAreas.map(a => {
//               const checked = selectedIds.includes(a.areaId);
//               return (
//                 <div
//                   key={a.areaId}
//                   onClick={() => toggle(a.areaId)}
//                   style={{
//                     display: "flex", alignItems: "center", gap: 9,
//                     padding: "9px 12px", cursor: "pointer",
//                     background: checked ? "#EFF6FF" : "transparent",
//                     borderBottom: "1px solid #F8FAFC",
//                   }}
//                   onMouseEnter={e => { if (!checked) e.currentTarget.style.background = "#F8FAFC"; }}
//                   onMouseLeave={e => { if (!checked) e.currentTarget.style.background = "transparent"; }}
//                 >
//                   <span style={{
//                     width: 16, height: 16, borderRadius: 4, flexShrink: 0,
//                     border: `2px solid ${checked ? BR : "#CBD5E1"}`,
//                     background: checked ? BR : "#fff",
//                     display: "inline-flex", alignItems: "center", justifyContent: "center",
//                   }}>
//                     {checked && <span style={{ color: "#fff", fontSize: 10, fontWeight: 900, lineHeight: 1 }}>✓</span>}
//                   </span>
//                   <span style={{ fontSize: 13, color: checked ? BR : "#1E293B", fontWeight: checked ? 600 : 400, fontFamily: "'Poppins', sans-serif" }}>
//                     {a.areaName}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ── Customer Detail Modal ──────────────────────────────────────────────────
// function CustomerDetailModal({ followup, employeeMap, budgetMap, onClose }) {
//   const customer     = followup?.enquiry?.customer || {};
//   const statusName   = followup?.status?.statusName || "";
//   const priorityName = followup?.priority?.priorityName || followup?.enquiry?.priority?.priorityName || "";
//   const areaLabel    = (() => {
//     const areas = followup?.enquiry?.areas;
//     if (Array.isArray(areas) && areas.length > 0)
//       return areas.map(a => a.areaName || a.name || "").filter(Boolean).join(", ");
//     return null;
//   })();

//   const mediaName   = followup?.media?.communicationmediaName || null;
//   const lastContact = followup?.callLeadDate ? new Date(followup.callLeadDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : null;

//   const assignId = followup?.assignTo;
//   const empInfo  = assignId ? employeeMap[assignId] : null;
//   const empName  = empInfo?.name || (assignId ? `#${assignId}` : null);

//   const historyRows = [followup].filter(Boolean);

//   const formatDateTime = (d) => {
//     if (!d) return { date: "—", time: "" };
//     const dt = new Date(d);
//     return {
//       date: dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }),
//       time: dt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true }),
//     };
//   };

//   const handleBackdrop = (e) => { if (e.target === e.currentTarget) onClose(); };

//   useEffect(() => {
//     const handler = (e) => { if (e.key === "Escape") onClose(); };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const InfoRow = ({ label, value, colorLeft = "#F97316" }) => (
//     <div style={{ display: "flex", borderBottom: "1px solid #F1F5F9" }}>
//       <div style={{ borderLeft: `3px solid ${colorLeft}`, padding: "12px 16px", minWidth: 140, fontSize: 13, fontWeight: 600, color: colorLeft, background: "#FAFAFA", flexShrink: 0 }}>
//         {label}
//       </div>
//       <div style={{ padding: "12px 16px", fontSize: 13, color: "#1E293B", display: "flex", alignItems: "center", flex: 1 }}>
//         {value}
//       </div>
//     </div>
//   );

  

//   const LEFT_COLORS = ["#F97316", "#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#6366F1"];

//   return (
//     <div
//       onClick={handleBackdrop}
//       style={{
//         position: "fixed", inset: 0, zIndex: 9999,
//         background: "rgba(15,23,42,0.55)",
//         backdropFilter: "blur(3px)",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         padding: "16px",
//         animation: "fadeIn .2s ease",
//       }}
//     >
//       <div style={{
//         background: "#fff", borderRadius: 16, width: "100%", maxWidth: 760,
//         maxHeight: "92vh", overflowY: "auto",
//         boxShadow: "0 24px 64px rgba(0,0,0,.22)",
//         animation: "slideUp .25s cubic-bezier(0.34,1.56,0.64,1)",
//         fontFamily: "'Poppins', sans-serif",
//       }}>
//         {/* Modal Header */}
//         <div style={{
//           display: "flex", alignItems: "center", gap: 14,
//           padding: "16px 20px", borderBottom: "1px solid #F1F5F9",
//           position: "sticky", top: 0, background: "#fff", zIndex: 10,
//           borderRadius: "16px 16px 0 0",
//         }}>
//           <div style={{ width: 38, height: 38, borderRadius: 10, background: "#EFF6FF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>👁️</div>
//           <div style={{ flex: 1 }}>
//             <div style={{ fontSize: 16, fontWeight: 700, color: "#1E293B", lineHeight: 1.2 }}>{customer.customerName || "—"}</div>
//             <div style={{ fontSize: 11.5, color: "#94A3B8", marginTop: 1 }}>Communication History</div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{ width: 34, height: 34, borderRadius: 8, background: "#F1F5F9", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, color: "#64748B", fontWeight: 700, flexShrink: 0, transition: "all .15s" }}
//             onMouseEnter={e => { e.currentTarget.style.background = "#FEE2E2"; e.currentTarget.style.color = "#DC2626"; }}
//             onMouseLeave={e => { e.currentTarget.style.background = "#F1F5F9"; e.currentTarget.style.color = "#64748B"; }}
//           >✕</button>
//         </div>

//         {/* Customer Info */}
//         <div style={{ margin: "16px 20px", borderRadius: 10, overflow: "hidden", border: "1px solid #F1F5F9", boxShadow: "0 1px 4px rgba(0,0,0,.05)" }}>
//           <InfoRow colorLeft={LEFT_COLORS[0]} label="Customer" value={
//             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//               <Avatar name={customer.customerName} size={28} />
//               <span style={{ fontWeight: 600 }}>{customer.customerName || "—"}</span>
//             </div>
//           } />
//           <InfoRow colorLeft={LEFT_COLORS[1]} label="Mobile" value={<span style={{ fontWeight: 600, letterSpacing: "0.5px" }}>{customer.mobileno || "—"}</span>} />
//           <InfoRow colorLeft={LEFT_COLORS[2]} label="Area" value={
//             areaLabel
//               ? <span style={{ background: "#FFF7ED", color: "#9A3412", padding: "2px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600 }}>📍 {areaLabel}</span>
//               : <span style={{ color: "#CBD5E1" }}>—</span>
//           } />
//           <InfoRow colorLeft={LEFT_COLORS[3]} label="Communication" value={
//             mediaName
//               ? <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F0FDF4", border: "1px solid #BBF7D0", color: "#166534", padding: "3px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600 }}>📞 {mediaName}</span>
//               : <span style={{ background: "#F1F5F9", border: "1px solid #E2E8F0", color: "#64748B", padding: "3px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5 }}>📞 —</span>
//           } />
//           <InfoRow colorLeft={LEFT_COLORS[4]} label="Priority" value={<PriorityBadge priorityName={priorityName} />} />
//           <InfoRow colorLeft={LEFT_COLORS[5]} label="Last Contact" value={
//             lastContact
//               ? <span style={{ fontWeight: 600, color: "#475569" }}>{lastContact}</span>
//               : <span style={{ color: "#CBD5E1" }}>—</span>
//           } />
//           <InfoRow colorLeft="#6366F1" label="Status" value={<StatusBadge statusName={statusName} />} />
//         </div>

//         {/* Communication History */}
//         <div style={{ margin: "0 20px 20px" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 0 10px", borderTop: "2px solid #F1F5F9", marginBottom: 0 }}>
//             <span style={{ fontSize: 14 }}>🕐</span>
//             <span style={{ fontSize: 13, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase" }}>Communication History</span>
//             <span style={{ background: "#EFF6FF", color: BR, borderRadius: 20, padding: "1px 9px", fontSize: 11.5, fontWeight: 700, marginLeft: 2 }}>{historyRows.length}</span>
//           </div>
//           <div style={{ borderRadius: 10, overflow: "hidden", border: "1px solid #F1F5F9", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 620 }}>
//                 <thead>
//                   <tr style={{ background: "#F8FAFC", borderBottom: "2px solid #E2E8F0" }}>
//                     {["#", "Date & Time", "Media", "Status", "Priority", "Assigned To", "Note", "Active"].map(h => (
//                       <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase", whiteSpace: "nowrap", fontFamily: "'Poppins', sans-serif" }}>{h}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {historyRows.map((row, idx) => {
//                     const rDt      = formatDateTime(row?.callLeadDate);
//                     const rMedia   = row?.media?.communicationmediaName || null;
//                     const rStatus  = row?.status?.statusName || "";
//                     const rPri     = row?.priority?.priorityName || row?.enquiry?.priority?.priorityName || "";
//                     const rAssign  = row?.assignTo ? employeeMap[row.assignTo] : null;
//                     const rEmpName = rAssign?.name || (row?.assignTo ? `#${row.assignTo}` : null);
//                     const rNote    = row?.followupRemark || null;
//                     const isActive = row?.isActive !== 0;
//                     return (
//                       <tr key={idx} style={{ borderBottom: "1px solid #F8FAFC", background: "#fff" }}>
//                         <td style={{ padding: "10px 12px", fontSize: 12.5, color: "#94A3B8", fontWeight: 600 }}>{idx + 1}</td>
//                         <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
//                           <div style={{ fontSize: 13, fontWeight: 600, color: "#1E293B" }}>{rDt.date}</div>
//                           <div style={{ fontSize: 11, color: "#94A3B8" }}>{rDt.time}</div>
//                         </td>
//                         <td style={{ padding: "10px 12px" }}>
//                           {rMedia ? <span style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", color: "#475569", padding: "2px 8px", borderRadius: 6, fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>📞 {rMedia}</span>
//                             : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                         </td>
//                         <td style={{ padding: "10px 12px" }}><StatusBadge statusName={rStatus} /></td>
//                         <td style={{ padding: "10px 12px" }}><PriorityBadge priorityName={rPri} /></td>
//                         <td style={{ padding: "10px 12px" }}>
//                           {rEmpName ? (
//                             <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                               <Avatar name={rEmpName} size={24} />
//                               <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1E293B" }}>{rEmpName}</span>
//                             </div>
//                           ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                         </td>
//                         <td style={{ padding: "10px 12px", maxWidth: 160 }}>
//                           {rNote ? <span title={rNote} style={{ fontSize: 12, color: "#475569", fontStyle: "italic", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>💬 {rNote}</span>
//                             : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                         </td>
//                         <td style={{ padding: "10px 12px" }}>
//                           <span style={{ background: isActive ? "#DCFCE7" : "#F1F5F9", color: isActive ? "#166534" : "#64748B", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
//                             {isActive ? "Active" : "Inactive"}
//                           </span>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// const formatDate = (d) => {
//   if (!d) return "—";
//   return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// };

// const getAreaLabel = (enquiry) => {
//   if (!enquiry) return null;
//   const areas = enquiry.areas;
//   if (Array.isArray(areas) && areas.length > 0)
//     return areas.map(a => a.areaName || a.name || "").filter(Boolean).join(", ") || null;
//   return null;
// };

// const getAreaIds = (enquiry) => {
//   if (!enquiry?.areas) return [];
//   return enquiry.areas.map(a => a.areaId).filter(Boolean);
// };

// const PER_PAGE = 10;

// export default function FollowupReport() {
//   const [allData, setAllData]             = useState([]);
//   const [loading, setLoading]             = useState(true);
//   const [error, setError]                 = useState(null);
//   const [statusFilter, setStatusFilter]   = useState("All");
//   const [startDate, setStartDate]         = useState("");
//   const [endDate, setEndDate]             = useState("");
//   const [searchQuery, setSearchQuery]     = useState("");
//   const [selectedAreas, setSelectedAreas] = useState([]);
//   const [page, setPage]                   = useState(1);
//   const [selectedFollowup, setSelectedFollowup] = useState(null);
//   const [exporting, setExporting]         = useState(false);

//   const [employeeMap, setEmployeeMap] = useState({});
//   const [budgetMap, setBudgetMap]     = useState({});
//   const [areaList, setAreaList]       = useState([]);

//   // Store logo as base64 for print
//   const [logoBase64, setLogoBase64] = useState("");

//   // Convert imported logo to base64 on mount
//   useEffect(() => {
//     const img = new Image();
//     img.crossOrigin = "anonymous";
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width  = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(img, 0, 0);
//       try {
//         setLogoBase64(canvas.toDataURL("image/png"));
//       } catch (_) {}
//     };
//     img.onerror = () => {};
//     img.src = crmLogo;
//   }, []);

//   const fetchAreas = useCallback(async () => {
//     try {
//       const filter = JSON.stringify({ where: { isActive: 1 }, order: ["areaName ASC"] });
//       const res = await fetch(`${AREA_API_URL}?filter=${encodeURIComponent(filter)}`);
//       if (!res.ok) return;
//       const ct = res.headers.get("content-type");
//       if (!ct?.includes("application/json")) return;
//       const json = await res.json();
//       if (!Array.isArray(json)) return;
//       setAreaList(json.map(a => ({ areaId: a.areaId ?? a.id, areaName: a.areaName ?? a.name ?? `Area #${a.areaId ?? a.id}` })));
//     } catch (_) {}
//   }, []);

//   const fetchBudgets = useCallback(async () => {
//     try {
//       const res = await fetch(`${BUDGET_API_URL}?filter=${encodeURIComponent(JSON.stringify({ where: { isActive: 1 } }))}`);
//       if (!res.ok) return;
//       const ct = res.headers.get("content-type");
//       if (!ct?.includes("application/json")) return;
//       const json = await res.json();
//       if (!Array.isArray(json)) return;
//       const map = {};
//       json.forEach((b) => {
//         const id = b.budgetId ?? b.id;
//         if (id == null) return;
//         const label = b.budgetName ?? b.budgetRange ?? b.budgetLabel ?? b.name ?? b.label ?? null;
//         const min   = b.minAmount ?? b.minBudget ?? b.min ?? b.budgetMin ?? null;
//         const max   = b.maxAmount ?? b.maxBudget ?? b.max ?? b.budgetMax ?? null;
//         map[id] = { label, min, max };
//       });
//       setBudgetMap(map);
//     } catch (_) {}
//   }, []);

//   const navigate = useNavigate();

//   const fetchEmployees = useCallback(async () => {
//     try {
//       const filter = JSON.stringify({ where: { isActive: 1 } });
//       const res = await fetch(`${EMP_API_URL}?filter=${encodeURIComponent(filter)}`);
//       if (!res.ok) return;
//       const ct = res.headers.get("content-type");
//       if (!ct?.includes("application/json")) return;
//       const json = await res.json();
//       if (!Array.isArray(json)) return;
//       const map = {};
//       json.forEach((emp) => {
//         const id    = emp.employeeId ?? emp.id;
//         const name  = emp.employeeName ?? emp.name ?? `Emp #${id}`;
//         const desig = emp.designation ?? emp.designationName ?? "";
//         if (id != null) map[id] = { name, desig };
//       });
//       setEmployeeMap(map);
//     } catch (_) {}
//   }, []);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const filter = JSON.stringify({ where: { isActive: 1 }, order: ["followupId DESC"] });
//       const res = await fetch(`${API_URL}?filter=${encodeURIComponent(filter)}`);
//       if (!res.ok) throw new Error(`Server error ${res.status}`);
//       const ct = res.headers.get("content-type");
//       if (!ct?.includes("application/json"))
//         throw new Error(`Expected JSON but got HTML — check API URL: ${API_URL}`);
//       const json = await res.json();
//       setAllData(Array.isArray(json) ? json : []);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchData();
//     fetchEmployees();
//     fetchBudgets();
//     fetchAreas();
//   }, [fetchData, fetchEmployees, fetchBudgets, fetchAreas]);

//   const getBudgetDisplay = (fkBudgetId) => {
//     if (!fkBudgetId) return null;
//     const b = budgetMap[fkBudgetId];
//     if (!b) return null;
//     if (b.label) return b.label;
//     if (b.min != null && b.max != null)
//       return `₹${Number(b.min).toLocaleString("en-IN")} – ₹${Number(b.max).toLocaleString("en-IN")}`;
//     if (b.min != null) return `₹${Number(b.min).toLocaleString("en-IN")}+`;
//     if (b.max != null) return `Up to ₹${Number(b.max).toLocaleString("en-IN")}`;
//     return `Budget #${fkBudgetId}`;
//   };

//   const filtered = allData.filter((f) => {
//     const statusName = f.status?.statusName || "";
//     const sn = statusName.toLowerCase();

//     if (statusFilter === "Follow Up"     && !sn.includes("follow"))  return false;
//     if (statusFilter === "Success Close" && !sn.includes("success")) return false;
//     if (statusFilter === "Cancel"        && !sn.includes("cancel"))  return false;

//     if (selectedAreas.length > 0) {
//       const rowAreaIds = getAreaIds(f.enquiry);
//       if (!rowAreaIds.some(id => selectedAreas.includes(id))) return false;
//     }

//     if (startDate || endDate) {
//       const d = f.callLeadDate ? new Date(f.callLeadDate) : null;
//       if (!d) return false;
//       if (startDate && d < new Date(startDate))             return false;
//       if (endDate   && d > new Date(endDate + "T23:59:59")) return false;
//     }

//     if (searchQuery.trim()) {
//       const q            = searchQuery.trim().toLowerCase();
//       const customer     = f.enquiry?.customer || {};
//       const empName      = (employeeMap[f.assignTo]?.name || "").toLowerCase();
//       const areaLabel    = (getAreaLabel(f.enquiry) || "").toLowerCase();
//       const customerName = (customer.customerName || "").toLowerCase();
//       const mobile       = (customer.mobileno || "").toLowerCase();
//       const enquiryId    = String(f.fkenquiryId || "");
//       const followupId   = String(f.followupId  || "");
//       const note         = (f.followupRemark || "").toLowerCase();

//       if (
//         !customerName.includes(q) && !mobile.includes(q) &&
//         !enquiryId.includes(q)    && !followupId.includes(q) &&
//         !empName.includes(q)      && !areaLabel.includes(q) &&
//         !note.includes(q)
//       ) return false;
//     }

//     return true;
//   });

//   useEffect(() => { setPage(1); }, [statusFilter, startDate, endDate, searchQuery, selectedAreas]);

//   const totalPages = Math.ceil(filtered.length / PER_PAGE);
//   const paginated  = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

//   const statsTotal   = filtered.length;
//   const statsFollow  = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("follow")).length;
//   const statsSuccess = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("success")).length;
//   const statsCancel  = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("cancel")).length;

//   const clearFilters = () => {
//     setStatusFilter("All"); setStartDate(""); setEndDate("");
//     setSearchQuery(""); setSelectedAreas([]);
//   };
//   const isFiltered = statusFilter !== "All" || startDate || endDate || searchQuery.trim() || selectedAreas.length > 0;

//   // ── Print Handler ─────────────────────────────────────────────────────────
//   // Columns: # | Customer Name | Mobile | Followup Date | Media | Area | Budget | Lead Status | Priority | Assigned To | Designation | Note/Remark
//   // (Followup Time & Active columns removed)
//   const handlePrint = () => {
//     const customer_rows = filtered.map((f, idx) => {
//       const customer      = f.enquiry?.customer || {};
//       const statusName    = f.status?.statusName || "New";
//       const priorityName  = f.priority?.priorityName || f.enquiry?.priority?.priorityName || "—";
//       const mediaName     = f.media?.communicationmediaName || "—";
//       const areaLabel     = getAreaLabel(f.enquiry) || "—";
//       const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId) || "—";
//       const empInfo       = f.assignTo ? employeeMap[f.assignTo] : null;
//       const empName       = empInfo?.name || (f.assignTo ? `#${f.assignTo}` : "—");
//       const empDesig      = empInfo?.desig || "—";
//       const callDt        = f.callLeadDate ? new Date(f.callLeadDate) : null;
//       // Only date, no time
//       const dateStr       = callDt ? callDt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

//       const sn = statusName.toLowerCase();
//       const statusColor = sn.includes("follow") ? "#854D0E"
//         : sn.includes("success") ? "#166534"
//         : sn.includes("cancel")  ? "#991B1B"
//         : "#6D28D9";

//       return `
//         <tr style="background:${idx % 2 === 1 ? "#F8FAFC" : "#fff"}">
//           <td>${idx + 1}</td>
//           <td>${customer.customerName || "—"}</td>
//           <td>${customer.mobileno || "—"}</td>
//           <td>${dateStr}</td>
//           <td>${mediaName}</td>
//           <td>${areaLabel}</td>
//           <td>${budgetDisplay}</td>
//           <td style="color:${statusColor};font-weight:700">${statusName}</td>
//           <td>${priorityName}</td>
//           <td>${empName}</td>
//           <td>${empDesig}</td>
//           <td style="max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${f.followupRemark || "—"}</td>
//         </tr>`;
//     }).join("");

//     const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

//     // Logo img tag — use base64 if available, else fallback to src path
//     const logoImgTag = logoBase64
//       ? `<img class="print-logo" src="${logoBase64}" alt="Logo" />`
//       : `<img class="print-logo" src="${crmLogo}" alt="Logo" />`;

//     const printHtml = `<!DOCTYPE html>
// <html>
// <head>
//   <meta charset="utf-8"/>
//   <title>Follow-up Report</title>
//   <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
//   <style>
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body {
//       font-family: 'Poppins', sans-serif;
//       background: #fff;
//       padding: 24px 28px;
//       color: #1E293B;
//       font-size: 9px;
//     }
//     .print-header {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       margin-bottom: 12px;
//     }
//     .print-logo {
//       width: 64px;
//       height: 64px;
//       object-fit: contain;
//       margin-bottom: 6px;
//     }
//     .print-company-name {
//       font-size: 17px;
//       font-weight: 800;
//       color: #0d1b3e;
//       text-align: center;
//       margin-bottom: 8px;
//     }
//     .print-divider {
//       width: 100%;
//       height: 2px;
//       background: #0d1b3e;
//       margin-bottom: 8px;
//     }
//     .print-report-title {
//       font-size: 13px;
//       font-weight: 700;
//       color: #1D4ED8;
//       text-align: center;
//       text-decoration: underline;
//       text-underline-offset: 4px;
//       margin-bottom: 14px;
//       letter-spacing: 0.5px;
//     }
//     table {
//       width: 100%;
//       border-collapse: collapse;
//       font-size: 8.5px;
//       page-break-inside: auto;
//     }
//     thead { display: table-header-group; }
//     tr { page-break-inside: avoid; }
//     th {
//       background: #0d1b3e !important;
//       color: #ffffff !important;
//       padding: 7px 8px;
//       text-align: left;
//       font-size: 8px;
//       font-weight: 700;
//       letter-spacing: 0.4px;
//       text-transform: uppercase;
//       border: 1px solid #0d1b3e;
//       white-space: nowrap;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//     }
//     td {
//       padding: 6px 8px;
//       border: 1px solid #D1D5DB;
//       font-size: 8.5px;
//       color: #1E293B;
//       vertical-align: middle;
//       line-height: 1.4;
//     }
//     .print-footer {
//       margin-top: 12px;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       font-size: 8.5px;
//       color: #64748B;
//       border-top: 1px solid #E2E8F0;
//       padding-top: 8px;
//     }
//     @media print {
//       body { padding: 12px 16px; }
//       th {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//       tr td { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//     }
//   </style>
// </head>
// <body>
//   <div class="print-header">
//     ${logoImgTag}
//     <p class="print-company-name">वरदविनायक रिअल इन्फ्रा प्रा. लि.</p>
//     <div class="print-divider"></div>
//     <p class="print-report-title">Follow-up Report</p>
//   </div>

//   <table>
//     <thead>
//       <tr>
//         <th>#</th>
//         <th>Customer Name</th>
//         <th>Mobile</th>
//         <th>Followup Date</th>
//         <th>Media</th>
//         <th>Area</th>
//         <th>Budget</th>
//         <th>Lead Status</th>
//         <th>Priority</th>
//         <th>Assigned To</th>
//         <th>Designation</th>
//         <th>Note / Remark</th>
//       </tr>
//     </thead>
//     <tbody>
//       ${customer_rows}
//     </tbody>
//   </table>

//   <div class="print-footer">
//     <span>वरदविनायक रिअल इन्फ्रा प्रा. लि. — Confidential</span>
//     <span>Printed on: ${today} &nbsp;|&nbsp; Total Records: ${filtered.length}</span>
//   </div>

//   <script>
//     window.onload = function() {
//       window.print();
//       setTimeout(function() { window.close(); }, 500);
//     };
//   <\/script>
// </body>
// </html>`;

//     const printWindow = window.open("", "_blank", "width=1200,height=800");
//     if (!printWindow) {
//       alert("Popup blocked! Please allow popups for this site and try again.");
//       return;
//     }
//     printWindow.document.open();
//     printWindow.document.write(printHtml);
//     printWindow.document.close();
//   };

//   // ── Excel Export ──────────────────────────────────────────────────────────
//   const exportToExcel = () => {
//     if (filtered.length === 0) return;
//     setExporting(true);

//     try {
//       const rows = filtered.map((f, idx) => {
//         const customer      = f.enquiry?.customer || {};
//         const statusName    = f.status?.statusName || "New";
//         const priorityName  = f.priority?.priorityName || f.enquiry?.priority?.priorityName || "—";
//         const mediaName     = f.media?.communicationmediaName || "—";
//         const areaLabel     = getAreaLabel(f.enquiry) || "—";
//         const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId) || "—";
//         const empInfo       = f.assignTo ? employeeMap[f.assignTo] : null;
//         const empName       = empInfo?.name || (f.assignTo ? `#${f.assignTo}` : "—");
//         const empDesig      = empInfo?.desig || "—";
//         const callDt = f.callLeadDate ? new Date(f.callLeadDate) : null;

//         return {
//           "Sr No":           idx + 1,
//           "Followup ID":     f.followupId || "—",
//           "Enquiry ID":      f.fkenquiryId || "—",
//           "Followup Date":   callDt ? callDt.toLocaleDateString("en-IN") : "—",
//           "Followup Time":   callDt ? callDt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true }) : "—",
//           "Customer Name":   customer.customerName || "—",
//           "Mobile":          customer.mobileno || "—",
//           "Email":           customer.emailid || "—",
//           "City":            customer.city || "—",
//           "Area":            areaLabel,
//           "Budget":          budgetDisplay,
//           "Communication":   mediaName,
//           "Lead Status":     statusName,
//           "Priority":        priorityName,
//           "Assigned To":     empName,
//           "Designation":     empDesig,
//           "Remark / Note":   f.followupRemark || "—",
//           "Active":          f.isActive !== 0 ? "Yes" : "No",
//         };
//       });

//       const ws1 = XLSX.utils.json_to_sheet(rows);
//       ws1["!cols"] = [
//         { wch: 6 }, { wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 12 },
//         { wch: 24 }, { wch: 14 }, { wch: 26 }, { wch: 14 }, { wch: 24 },
//         { wch: 18 }, { wch: 16 }, { wch: 18 }, { wch: 12 }, { wch: 20 },
//         { wch: 18 }, { wch: 34 }, { wch: 8 },
//       ];

//       const range1 = XLSX.utils.decode_range(ws1["!ref"]);
//       for (let C = range1.s.c; C <= range1.e.c; C++) {
//         const cellAddr = XLSX.utils.encode_cell({ r: 0, c: C });
//         if (!ws1[cellAddr]) continue;
//         ws1[cellAddr].s = {
//           font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
//           fill: { fgColor: { rgb: "072877" } },
//           alignment: { horizontal: "center", vertical: "center", wrapText: true },
//         };
//       }

//       const today = new Date().toLocaleDateString("en-IN");
//       const summaryData = [
//         { "Summary": "Total Follow-ups",   "Count": statsTotal   },
//         { "Summary": "Follow Up",          "Count": statsFollow  },
//         { "Summary": "Success Close",      "Count": statsSuccess },
//         { "Summary": "Cancelled",          "Count": statsCancel  },
//         { "Summary": "Export Date",        "Count": today        },
//         { "Summary": "Filters Applied",    "Count": isFiltered ? "Yes" : "No" },
//         { "Summary": "Status Filter",      "Count": statusFilter },
//         { "Summary": "Date Range",         "Count": startDate && endDate ? `${startDate} to ${endDate}` : startDate ? `From ${startDate}` : endDate ? `To ${endDate}` : "All" },
//         { "Summary": "Areas Selected",     "Count": selectedAreas.length > 0 ? selectedAreas.map(id => areaList.find(a => a.areaId === id)?.areaName || id).join(", ") : "All" },
//       ];
//       const ws2 = XLSX.utils.json_to_sheet(summaryData);
//       ws2["!cols"] = [{ wch: 22 }, { wch: 34 }];

//       const range2 = XLSX.utils.decode_range(ws2["!ref"]);
//       for (let C = range2.s.c; C <= range2.e.c; C++) {
//         const cellAddr = XLSX.utils.encode_cell({ r: 0, c: C });
//         if (!ws2[cellAddr]) continue;
//         ws2[cellAddr].s = {
//           font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
//           fill: { fgColor: { rgb: "1D4ED8" } },
//           alignment: { horizontal: "center", vertical: "center" },
//         };
//       }

//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws1, "Followup Report");
//       XLSX.utils.book_append_sheet(wb, ws2, "Summary");

//       const fileName = `Followup_Report_${today.replace(/\//g, "-")}.xlsx`;
//       XLSX.writeFile(wb, fileName);

//     } catch (err) {
//       console.error("Export error:", err);
//       alert("Export failed: " + err.message);
//     } finally {
//       setExporting(false);
//     }
//   };

//   return (
//     <div style={{ width: "100%", minHeight: "100vh", background: "#F1F5F9", fontFamily: "'Poppins', sans-serif", paddingBottom: 40 }}>
//       <style>{`
//         @keyframes shimmer  { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
//         @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
//         @keyframes slideUp  { from{opacity:0;transform:translateY(24px) scale(.98)} to{opacity:1;transform:translateY(0) scale(1)} }
//         .rpt-row { transition: background .15s; cursor: pointer; }
//         .rpt-row:hover { background: #EFF6FF !important; }
//         .date-input {
//           height: 40px; border: 1.5px solid #E2E8F0; border-radius: 8px;
//           padding: 0 12px; font-size: 13px; font-family: 'Poppins', sans-serif;
//           color: #1E293B; outline: none; background: #fff; cursor: pointer;
//         }
//         .date-input:focus { border-color: #1D4ED8; }
//         .search-input {
//           height: 42px; border: 1.5px solid #E2E8F0; border-radius: 8px;
//           padding: 0 34px 0 36px; font-size: 13.5px; font-family: 'Poppins', sans-serif;
//           color: #1E293B; outline: none; background: #fff; min-width: 220px; transition: border-color .15s;
//         }
//         .search-input:focus { border-color: #1D4ED8; box-shadow: 0 0 0 3px rgba(29,78,216,.08); }
//         .search-input::placeholder { color: #94A3B8; }
//         .page-btn {
//           padding: 6px 14px; border-radius: 6px; border: 1.5px solid #E2E8F0;
//           background: #fff; cursor: pointer; font-size: 13px; font-weight: 600;
//           color: #1D4ED8; font-family: 'Poppins', sans-serif; transition: all .15s;
//         }
//         .page-btn:disabled { color: #CBD5E1; cursor: not-allowed; background: #F8FAFC; }
//         .page-btn.curr { background: #1D4ED8; color: #fff; border-color: #1D4ED8; }
//         .status-select {
//           height: 42px; border: 1.5px solid #E2E8F0; border-radius: 8px;
//           padding: 0 36px 0 14px; font-size: 13.5px; font-family: 'Poppins', sans-serif;
//           color: #1E293B; outline: none; background: #fff; cursor: pointer;
//           appearance: none; -webkit-appearance: none;
//           background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
//           background-repeat: no-repeat; background-position: right 12px center;
//           min-width: 180px; font-weight: 500;
//         }
//         .status-select:focus { border-color: #1D4ED8; }

//         /* ── Icon-only buttons ── */
//         .icon-btn {
//           width: 38px; height: 38px; border-radius: 10px;
//           border: none; cursor: pointer;
//           display: flex; align-items: center; justify-content: center;
//           font-size: 18px; transition: all .2s;
//           position: relative;
//           flex-shrink: 0;
//         }
//         .icon-btn:active { transform: scale(0.92); }

//         /* Print – red */
//         .print-icon-btn {
//           background: linear-gradient(135deg, #fa0505, #720202);
//           box-shadow: 0 2px 8px rgba(220,38,38,0.40);
//         }
//         .print-icon-btn:hover {
//           background: linear-gradient(135deg, #DC2626, #B91C1C);
//           box-shadow: 0 4px 14px rgba(220,38,38,0.52);
//           transform: translateY(-2px);
//         }

//         /* Excel – green */
//         .excel-icon-btn {
//           background: linear-gradient(135deg, #099443, #039c3b);
//           box-shadow: 0 2px 8px rgba(22,163,74,0.40);
//         }
//         .excel-icon-btn:hover {
//           background: linear-gradient(135deg, #16A34A, #15803D);
//           box-shadow: 0 4px 14px rgba(22,163,74,0.52);
//           transform: translateY(-2px);
//         }
//         .excel-icon-btn:disabled {
//           opacity: 0.55; cursor: not-allowed; transform: none;
//           box-shadow: none;
//         }

//         /* Tooltip */
//         .icon-btn-wrap { position: relative; display: inline-flex; }
//         .icon-btn-wrap .tooltip {
//           position: absolute; bottom: calc(100% + 7px); left: 50%;
//           transform: translateX(-50%);
//           background: rgba(15,23,42,0.88); color: #fff;
//           font-size: 11px; font-weight: 600; white-space: nowrap;
//           padding: 4px 9px; border-radius: 6px;
//           pointer-events: none; opacity: 0; transition: opacity .18s;
//           font-family: 'Poppins', sans-serif;
//         }
//         .icon-btn-wrap:hover .tooltip { opacity: 1; }

//         .export-btn {
//           background: linear-gradient(135deg, #16A34A, #15803D);
//           border: none; color: #fff; padding: 8px 20px; border-radius: 50px;
//           font-weight: 700; font-size: 13px; cursor: pointer;
//           font-family: 'Poppins', sans-serif;
//           display: flex; align-items: center; gap: 7px;
//           box-shadow: 0 2px 8px rgba(22,163,74,0.35);
//           transition: all .2s; white-space: nowrap;
//         }
//         .export-btn:hover { background: linear-gradient(135deg,#15803D,#166534); transform: translateY(-1px); box-shadow: 0 4px 14px rgba(22,163,74,0.45); }
//         .export-btn:active { transform: translateY(0); }
//         .export-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
//         .print-btn {
//           background: linear-gradient(135deg, #6366F1, #4F46E5);
//           border: none; color: #fff; padding: 8px 20px; border-radius: 50px;
//           font-weight: 700; font-size: 13px; cursor: pointer;
//           font-family: 'Poppins', sans-serif;
//           display: flex; align-items: center; gap: 7px;
//           box-shadow: 0 2px 8px rgba(99,102,241,0.35);
//           transition: all .2s; white-space: nowrap;
//         }
//         .print-btn:hover { background: linear-gradient(135deg,#4F46E5,#4338CA); transform: translateY(-1px); box-shadow: 0 4px 14px rgba(99,102,241,0.45); }
//         .print-btn:active { transform: translateY(0); }
//       `}</style>

//       {/* ── Header ─────────────────────────────────────────────────────── */}
//       <div style={{
//         background: "#0d1b3e",
//         backgroundImage: `repeating-linear-gradient(0deg,transparent,transparent 39px,rgba(255,255,255,0.018) 39px,rgba(255,255,255,0.018) 40px),
//           repeating-linear-gradient(90deg,transparent,transparent 39px,rgba(255,255,255,0.018) 39px,rgba(255,255,255,0.018) 40px)`,
//         padding: "0 28px", display: "flex", alignItems: "center",
//         justifyContent: "space-between", flexWrap: "wrap", gap: 16, minHeight: 76,
//       }}>
//         <div style={{ padding: "14px 0" }}>
//           <div style={{ fontSize: 9.5, fontWeight: 600, letterSpacing: "2px", textTransform: "uppercase", color: "rgba(148,163,184,0.65)", marginBottom: 3 }}>LEAD MANAGEMENT</div>
//           <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>📊 Follow-up Report</div>
//         </div>

//         {/* Header Buttons */}
//         <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>

//           {/* Print – icon only, red */}
//           {!loading && !error && filtered.length > 0 && (
//             <div className="icon-btn-wrap">
//               <button
//                 className="icon-btn print-icon-btn"
//                 onClick={handlePrint}
//                 title="Print"
//               >
//                 🖨️
//               </button>
//               <span className="tooltip">Print ({filtered.length})</span>
//             </div>
//           )}

//           {/* Excel – icon only, green */}
//           {!loading && !error && filtered.length > 0 && (
//             <div className="icon-btn-wrap">
//               <button
//                 className="icon-btn excel-icon-btn"
//                 onClick={exportToExcel}
//                 disabled={exporting}
//                 title="Export Excel"
//               >
//                 {exporting ? "⏳" : "📥"}
//               </button>
//               <span className="tooltip">{exporting ? "Exporting…" : `Export Excel (${filtered.length})`}</span>
//             </div>
//           )}

//           {/* Refresh Button */}
//           <button
//             onClick={() => { fetchData(); fetchEmployees(); fetchBudgets(); fetchAreas(); }}
//             style={{ background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.2)", color: "#fff", padding: "8px 18px", borderRadius: 50, fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "'Poppins', sans-serif", display: "flex", alignItems: "center", gap: 6 }}
//           >🔄 Refresh</button>
//         </div>
//       </div>

//       <div style={{ padding: "18px 16px" }}>

//         {/* Filter Bar */}
//         <div style={{ background: "#fff", borderRadius: 12, padding: "14px 18px", marginBottom: 12, display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end", boxShadow: "0 1px 6px rgba(7,40,119,.07)" }}>

//           <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Lead Status</label>
//             <select
//               className="status-select"
//               value={statusFilter}
//               onChange={e => setStatusFilter(e.target.value)}
//               style={{ borderColor: statusFilter !== "All" ? BR : "#E2E8F0", color: statusFilter !== "All" ? BR : "#1E293B", fontWeight: statusFilter !== "All" ? 700 : 500 }}
//             >
//               <option value="All">All Statuses</option>
//               <option value="Follow Up">🔁 Follow Up</option>
//               <option value="Success Close">✅ Success Close</option>
//               <option value="Cancel">❌ Cancel</option>
//             </select>
//           </div>

//           <AreaMultiSelect areas={areaList} selectedIds={selectedAreas} onChange={setSelectedAreas} />

//           <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Start Date</label>
//             <input type="date" className="date-input" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ borderColor: startDate ? BR : "#E2E8F0" }} />
//           </div>

//           <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>End Date</label>
//             <input type="date" className="date-input" value={endDate} onChange={e => setEndDate(e.target.value)} min={startDate || undefined} style={{ borderColor: endDate ? BR : "#E2E8F0" }} />
//           </div>

//           <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Search</label>
//             <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
//               <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", fontSize: 15, color: "#94A3B8", pointerEvents: "none" }}>🔍</span>
//               <input type="text" className="search-input" placeholder="Name, mobile, note…" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{ borderColor: searchQuery.trim() ? BR : "#E2E8F0" }} />
//               {searchQuery && (
//                 <button onClick={() => setSearchQuery("")} style={{ position: "absolute", right: 8, background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#94A3B8", padding: 0 }}>✕</button>
//               )}
//             </div>
//           </div>

// {/* Pie Chart Analytics Button */}
//           <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//             <label style={{ fontSize: 11, color: "transparent" }}>x</label>
//             <div className="icon-btn-wrap">
//               <button
//                 className="icon-btn"
//                 onClick={() => navigate("/followup-analytics")}
//                 style={{
//                   background: "linear-gradient(135deg, #7C3AED, #5B21B6)",
//                   boxShadow: "0 2px 8px rgba(124,58,237,0.40)",
//                   width: 42,
//                   height: 42,
//                 }}
//                 title="Analytics"
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//                   <path d="M12 2a10 10 0 0 1 10 10h-10z" fill="#fff" opacity="0.95"/>
//                   <path d="M12 12L4.93 17.07A10 10 0 0 1 2 12z" fill="#fff" opacity="0.65"/>
//                   <path d="M12 12v-10a10 10 0 0 0-7.07 17.07z" fill="#fff" opacity="0.80"/>
//                   <circle cx="12" cy="12" r="2.5" fill="#7C3AED"/>
//                 </svg>
//               </button>
//               <span className="tooltip">📊 Analytics</span>
//             </div>
//           </div>



//           {isFiltered && (
//             <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//               <label style={{ fontSize: 11, color: "transparent" }}>x</label>
//               <button onClick={clearFilters} style={{ height: 42, padding: "0 16px", borderRadius: 8, border: "1.5px solid #FECACA", background: "#FEF2F2", color: "#991B1B", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "'Poppins', sans-serif" }}>✕ Clear</button>
//             </div>
//           )}

//           <div style={{ marginLeft: "auto", fontSize: 13, color: "#64748B", fontWeight: 600, alignSelf: "flex-end", paddingBottom: 4 }}>
//             {filtered.length} record{filtered.length !== 1 ? "s" : ""}
//           </div>
//         </div>

//         {/* Area chips */}
//         {selectedAreas.length > 0 && (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
//             {selectedAreas.map(id => {
//               const a = areaList.find(x => x.areaId === id);
//               return (
//                 <span key={id} style={{ background: "#EFF6FF", color: BR, border: "1px solid #BFDBFE", borderRadius: 20, padding: "3px 10px", fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5, fontFamily: "'Poppins', sans-serif" }}>
//                   📍 {a?.areaName || id}
//                   <button onClick={() => setSelectedAreas(selectedAreas.filter(x => x !== id))} style={{ background: "none", border: "none", cursor: "pointer", color: BR, fontSize: 12, padding: 0, lineHeight: 1, fontWeight: 700 }}>✕</button>
//                 </span>
//               );
//             })}
//           </div>
//         )}

//         {/* Stat Cards */}
//         {!loading && !error && (
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 10, marginBottom: 16 }}>
//             {[
//               { label: "Total",         value: statsTotal,   bg: "#EFF6FF", color: BR,        icon: "📋" },
//               { label: "Follow Up",     value: statsFollow,  bg: "#FEF9C3", color: "#854D0E", icon: "🔁" },
//               { label: "Success Close", value: statsSuccess, bg: "#DCFCE7", color: "#166534", icon: "✅" },
//               { label: "Cancelled",     value: statsCancel,  bg: "#FEE2E2", color: "#991B1B", icon: "❌" },
//             ].map((c, i) => (
//               <div key={i} style={{ background: c.bg, borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, boxShadow: "0 1px 4px rgba(0,0,0,.05)" }}>
//                 <span style={{ fontSize: 22 }}>{c.icon}</span>
//                 <div>
//                   <div style={{ fontSize: 22, fontWeight: 800, color: c.color, lineHeight: 1.1 }}>{c.value}</div>
//                   <div style={{ fontSize: 11.5, color: "#64748B", fontWeight: 600 }}>{c.label}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Loading */}
//         {loading && (
//           <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 6px rgba(7,40,119,.06)" }}>
//             {[...Array(7)].map((_, i) => (
//               <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
//                 <Skeleton width={36} height={36} radius={50} />
//                 <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
//                   <Skeleton width="35%" height={13} />
//                   <Skeleton width="55%" height={11} />
//                 </div>
//                 <Skeleton width={90} height={24} radius={20} />
//                 <Skeleton width={70} height={24} radius={20} />
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Error */}
//         {error && !loading && (
//           <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 12, padding: "24px", textAlign: "center", color: "#991B1B" }}>
//             <div style={{ fontSize: 36, marginBottom: 8 }}>⚠️</div>
//             <div style={{ fontWeight: 700, marginBottom: 4 }}>API Error</div>
//             <div style={{ fontSize: 13, opacity: .8, marginBottom: 14 }}>{error}</div>
//             <button onClick={fetchData} style={{ padding: "8px 22px", borderRadius: 50, background: "#DC2626", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer", fontFamily: "'Poppins', sans-serif" }}>🔄 Retry</button>
//           </div>
//         )}

//         {/* Table */}
//         {!loading && !error && (
//           <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(7,40,119,.07)", overflow: "hidden", animation: "fadeIn .3s ease" }}>
//             {paginated.length === 0 ? (
//               <div style={{ padding: 52, textAlign: "center", color: "#94A3B8" }}>
//                 <div style={{ fontSize: 48, marginBottom: 12 }}>🔍</div>
//                 <div style={{ fontWeight: 700, fontSize: 16, color: "#64748B" }}>No records found</div>
//                 <div style={{ fontSize: 13, marginTop: 4 }}>Try changing the filters or search query</div>
//               </div>
//             ) : (
//               <div style={{ overflowX: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 860 }}>
//                   <thead>
//                     <tr style={{ background: "#F8FAFC", borderBottom: "2px solid #E2E8F0" }}>
//                       {["#", "Customer", "Follow-up Date", "Media", "Budget", "Area", "Lead Status", "Note", "Assigned To"].map(h => (
//                         <th key={h} style={{ padding: "11px 12px", textAlign: "left", fontSize: 11.5, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase", whiteSpace: "nowrap", fontFamily: "'Poppins', sans-serif" }}>
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paginated.map((f, idx) => {
//                       const srNo          = (page - 1) * PER_PAGE + idx + 1;
//                       const customer      = f.enquiry?.customer || {};
//                       const statusName    = f.status?.statusName || (f.fkLeadStatusId === 0 ? "New" : "");
//                       const mediaName     = f.media?.communicationmediaName || "—";
//                       const assignId      = f.assignTo;
//                       const areaLabel     = getAreaLabel(f.enquiry);
//                       const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId);
//                       const empInfo       = assignId ? employeeMap[assignId] : null;
//                       const empName       = empInfo?.name  || (assignId ? `#${assignId}` : null);
//                       const empDesig      = empInfo?.desig || "";
//                       const note          = f.followupRemark || null;

//                       return (
//                         <tr
//                           key={f.followupId}
//                           className="rpt-row"
//                           style={{ borderBottom: "1px solid #F1F5F9" }}
//                           onClick={() => setSelectedFollowup(f)}
//                           title="Click to view details"
//                         >
//                           <td style={{ padding: "10px 12px", fontSize: 12.5, color: "#94A3B8", fontWeight: 600 }}>{srNo}</td>
//                           <td style={{ padding: "10px 12px" }}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <Avatar name={customer.customerName} size={30} />
//                               <div>
//                                 <div style={{ fontWeight: 700, fontSize: 13, color: "#1E293B" }}>{customer.customerName || "—"}</div>
//                                 <div style={{ fontSize: 11, color: "#94A3B8" }}>{customer.mobileno || ""}</div>
//                               </div>
//                             </div>
//                           </td>
//                           <td style={{ padding: "10px 12px", fontSize: 13, color: "#475569", whiteSpace: "nowrap" }}>{formatDate(f.callLeadDate)}</td>
//                           <td style={{ padding: "10px 12px" }}>
//                             {mediaName !== "—"
//                               ? <span style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", color: "#475569", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 600 }}>{mediaName}</span>
//                               : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                           </td>
//                           <td style={{ padding: "10px 12px" }}>
//                             {budgetDisplay
//                               ? <span style={{ background: "#F0FDF4", color: "#166534", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap" }}>{budgetDisplay}</span>
//                               : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                           </td>
//                           <td style={{ padding: "10px 12px" }}>
//                             {areaLabel
//                               ? <span style={{ background: "#FFF7ED", color: "#9A3412", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>📍 {areaLabel}</span>
//                               : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                           </td>
//                           <td style={{ padding: "10px 12px" }}><StatusBadge statusName={statusName} /></td>
//                           <td style={{ padding: "10px 12px", maxWidth: 190 }}>
//                             {note ? (
//                               <span title={note} style={{ display: "block", fontSize: 12.5, color: "#475569", fontStyle: "italic", lineHeight: 1.4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
//                                 💬 {note}
//                               </span>
//                             ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                           </td>
//                           <td style={{ padding: "10px 12px" }}>
//                             {empName ? (
//                               <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
//                                 <Avatar name={empName} size={26} />
//                                 <div>
//                                   <div style={{ fontWeight: 700, fontSize: 12.5, color: "#1E293B", lineHeight: 1.2 }}>{empName}</div>
//                                   {empDesig && <div style={{ fontSize: 10.5, color: "#94A3B8", fontWeight: 500 }}>{empDesig}</div>}
//                                 </div>
//                               </div>
//                             ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div style={{ borderTop: "1px solid #F1F5F9", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
//                 <span style={{ fontSize: 13, color: "#64748B" }}>
//                   Showing {(page - 1) * PER_PAGE + 1}–{Math.min(page * PER_PAGE, filtered.length)} of {filtered.length}
//                 </span>
//                 <div style={{ display: "flex", gap: 6 }}>
//                   <button className="page-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>← Prev</button>
//                   {[...Array(totalPages)].map((_, i) =>
//                     Math.abs(page - (i + 1)) <= 2 && (
//                       <button key={i} className={`page-btn${page === i + 1 ? " curr" : ""}`} onClick={() => setPage(i + 1)}>{i + 1}</button>
//                     )
//                   )}
//                   <button className="page-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>Next →</button>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Customer Detail Modal */}
//       {selectedFollowup && (
//         <CustomerDetailModal
//           followup={selectedFollowup}
//           employeeMap={employeeMap}
//           budgetMap={budgetMap}
//           onClose={() => setSelectedFollowup(null)}
//         />
//       )}
//     </div>
//   );
// }



import React, { useState, useEffect, useCallback, useRef } from "react";
import * as XLSX from "xlsx";
import { URL } from "../config";
import crmLogo from "../assets/crmimg.png";
import { useNavigate } from "react-router-dom";

const API_URL        = `${URL}/followup-masters`;
const EMP_API_URL    = `${URL}/employee-masters`;
const BUDGET_API_URL = `${URL}/budget-masters`;
const AREA_API_URL   = `${URL}/area-masters`;

if (typeof document !== "undefined" && !document.getElementById("poppins-font")) {
  const link = document.createElement("link");
  link.id   = "poppins-font";
  link.rel  = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap";
  document.head.appendChild(link);
}

const BR = "#1D4ED8";

const AVATAR_COLORS = [
  "#1D4ED8","#7C3AED","#DB2777","#D97706","#059669",
  "#DC2626","#2563EB","#9333EA","#EA580C","#0891B2",
];
const getAvatarColor = (name) => {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
const getInitials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const STATUS_CONFIG = {
  "followup":      { bg: "#FEF9C3", color: "#854D0E", label: "Follow Up",     dot: "#D97706" },
  "success close": { bg: "#DCFCE7", color: "#166534", label: "Success Close", dot: "#16A34A" },
  "cancel":        { bg: "#FEE2E2", color: "#991B1B", label: "Cancel",        dot: "#DC2626" },
};
const getStatusCfg = (name) => {
  if (!name) return { bg: "#F5F3FF", color: "#6D28D9", label: "New", dot: "#7C3AED" };
  const n = name.toLowerCase();
  if (n.includes("follow"))  return STATUS_CONFIG["followup"];
  if (n.includes("success")) return STATUS_CONFIG["success close"];
  if (n.includes("cancel"))  return STATUS_CONFIG["cancel"];
  return { bg: "#F5F3FF", color: "#6D28D9", label: name, dot: "#7C3AED" };
};

const PRIORITY_CONFIG = {
  high:   { bg: "#FEE2E2", color: "#991B1B", label: "High",   dash: false },
  medium: { bg: "#FEF9C3", color: "#854D0E", label: "Medium", dash: true  },
  low:    { bg: "#DCFCE7", color: "#166534", label: "Low",    dash: false },
};
const getPriorityCfg = (name) => {
  if (!name) return { bg: "#F1F5F9", color: "#64748B", label: "—", dash: true };
  const n = name.toLowerCase();
  if (n.includes("high"))   return PRIORITY_CONFIG["high"];
  if (n.includes("medium")) return PRIORITY_CONFIG["medium"];
  if (n.includes("low"))    return PRIORITY_CONFIG["low"];
  return { bg: "#F1F5F9", color: "#64748B", label: name, dash: false };
};

function Avatar({ name, size = 32 }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%",
      background: getAvatarColor(name), color: "#fff",
      fontSize: size * 0.38, fontWeight: 700, flexShrink: 0, lineHeight: 1,
      fontFamily: "'Poppins', sans-serif",
    }}>
      {getInitials(name)}
    </span>
  );
}

function StatusBadge({ statusName }) {
  const cfg = getStatusCfg(statusName);
  return (
    <span style={{
      background: cfg.bg, color: cfg.color,
      padding: "3px 10px", borderRadius: 20, fontSize: 11.5,
      fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 5,
      fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap",
    }}>
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: cfg.dot, flexShrink: 0 }} />
      {cfg.label}
    </span>
  );
}

function PriorityBadge({ priorityName }) {
  const cfg = getPriorityCfg(priorityName);
  return (
    <span style={{
      background: cfg.bg, color: cfg.color,
      padding: "3px 10px", borderRadius: 20, fontSize: 11.5,
      fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 5,
      fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap",
    }}>
      {cfg.dash && <span style={{ fontWeight: 900, fontSize: 13, lineHeight: 1 }}>—</span>}
      {cfg.label}
    </span>
  );
}

function Skeleton({ width = "100%", height = 16, radius = 6 }) {
  return (
    <div style={{
      width, height, borderRadius: radius,
      background: "linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.4s infinite",
    }} />
  );
}

// ── Employee Stats Modal ───────────────────────────────────────────────────
function EmployeeStatsModal({ employeeId, employeeName, allData, onClose }) {
  const empFollowups = allData.filter(
    f => f.assignTo === employeeId || f.assignTo === Number(employeeId)
  );

  const called    = empFollowups.filter(f => f.isActive === 0).length;
  const notCalled = empFollowups.filter(f => f.isActive === 1).length;
  const total     = empFollowups.length;

  const successCount = empFollowups.filter(f =>
    (f.status?.statusName || "").toLowerCase().includes("success")
  ).length;
  const followupCount = empFollowups.filter(f =>
    (f.status?.statusName || "").toLowerCase().includes("follow")
  ).length;
  const cancelCount = empFollowups.filter(f =>
    (f.status?.statusName || "").toLowerCase().includes("cancel")
  ).length;

  const calledPct    = total > 0 ? Math.round((called    / total) * 100) : 0;
  const notCalledPct = total > 0 ? Math.round((notCalled / total) * 100) : 0;

  const handleBackdrop = (e) => { if (e.target === e.currentTarget) onClose(); };
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      onClick={handleBackdrop}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(15,23,42,0.55)",
        backdropFilter: "blur(3px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px",
        animation: "fadeIn .2s ease",
      }}
    >
      <div style={{
        background: "#fff", borderRadius: 16, width: "100%", maxWidth: 520,
        boxShadow: "0 24px 64px rgba(0,0,0,.22)",
        animation: "slideUp .25s cubic-bezier(0.34,1.56,0.64,1)",
        fontFamily: "'Poppins', sans-serif",
        overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{
          background: "#0d1b3e",
          padding: "16px 20px",
          display: "flex", alignItems: "center", gap: 14,
        }}>
          <Avatar name={employeeName} size={42} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>{employeeName}</div>
            <div style={{ fontSize: 12, color: "rgba(148,163,184,0.8)", marginTop: 2 }}>Employee Call Statistics</div>
          </div>
          <button
            onClick={onClose}
            style={{
              width: 32, height: 32, borderRadius: 8,
              background: "rgba(255,255,255,.12)", border: "none",
              cursor: "pointer", color: "#fff", fontSize: 16, fontWeight: 700,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >✕</button>
        </div>

        {/* Stats Grid */}
        <div style={{ padding: "20px" }}>
          {/* Main stats */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 16 }}>
            {[
              { label: "Total Leads",  value: total,          bg: "#EFF6FF", color: BR,        icon: "📋" },
              { label: "Called",       value: called,         bg: "#DCFCE7", color: "#166534", icon: "✅" },
              { label: "Not Called",   value: notCalled,      bg: "#FEF9C3", color: "#854D0E", icon: "⏳" },
            ].map((s, i) => (
              <div key={i} style={{ background: s.bg, borderRadius: 10, padding: "14px 16px", textAlign: "center" }}>
                <div style={{ fontSize: 22, marginBottom: 4 }}>{s.icon}</div>
                <div style={{ fontSize: 26, fontWeight: 800, color: s.color, lineHeight: 1 }}>{s.value}</div>
                <div style={{ fontSize: 11, color: "#64748B", fontWeight: 600, marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Progress Bar */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#166534" }}>✅ Called ({calledPct}%)</span>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#854D0E" }}>⏳ Not Called ({notCalledPct}%)</span>
            </div>
            <div style={{ height: 12, borderRadius: 6, background: "#FEF9C3", overflow: "hidden" }}>
              <div style={{
                height: "100%", background: "#16A34A", borderRadius: 6,
                width: `${calledPct}%`, transition: "width .6s ease",
                minWidth: calledPct > 0 ? 8 : 0,
              }} />
            </div>
          </div>

          {/* Lead Status Breakdown */}
          <div style={{ borderTop: "1px solid #F1F5F9", paddingTop: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#94A3B8", letterSpacing: "0.5px", textTransform: "uppercase", marginBottom: 12 }}>Lead Status Breakdown</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
              {[
                { label: "Follow Up",     value: followupCount, bg: "#FEF9C3", color: "#854D0E", dot: "#D97706" },
                { label: "Success Close", value: successCount,  bg: "#DCFCE7", color: "#166534", dot: "#16A34A" },
                { label: "Cancelled",     value: cancelCount,   bg: "#FEE2E2", color: "#991B1B", dot: "#DC2626" },
              ].map((s, i) => (
                <div key={i} style={{ background: s.bg, borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5, marginBottom: 4 }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: s.dot, display: "inline-block" }} />
                    <span style={{ fontSize: 10.5, fontWeight: 700, color: s.color }}>{s.label}</span>
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: s.color }}>{s.value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            style={{
              width: "100%", marginTop: 20, height: 42, borderRadius: 8,
              background: "#0d1b3e", border: "none", color: "#fff",
              fontSize: 14, fontWeight: 700, cursor: "pointer",
              fontFamily: "'Poppins', sans-serif",
            }}
          >Close</button>
        </div>
      </div>
    </div>
  );
}

// ── Area Multi-Select Dropdown ─────────────────────────────────────────────
function AreaMultiSelect({ areas, selectedIds, onChange }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState("");
  const ref                 = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filteredAreas = areas.filter(a =>
    (a.areaName || "").toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (id) => {
    onChange(selectedIds.includes(id)
      ? selectedIds.filter(x => x !== id)
      : [...selectedIds, id]
    );
  };

  const isActive = selectedIds.length > 0;
  const label = !isActive
    ? "All Areas"
    : selectedIds.length === 1
      ? (areas.find(a => a.areaId === selectedIds[0])?.areaName || "1 selected")
      : `${selectedIds.length} areas selected`;

  return (
    <div ref={ref} style={{ position: "relative", display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Area</label>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          height: 42, padding: "0 36px 0 14px", borderRadius: 8,
          border: `1.5px solid ${isActive ? BR : "#E2E8F0"}`,
          background: "#fff", cursor: "pointer", fontSize: 13.5,
          fontFamily: "'Poppins', sans-serif",
          color: isActive ? BR : "#1E293B", fontWeight: isActive ? 700 : 500,
          textAlign: "left", minWidth: 180,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
        }}
      >
        {label}
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 1000,
          background: "#fff", borderRadius: 10,
          border: "1.5px solid #E2E8F0", minWidth: 230,
          boxShadow: "0 8px 24px rgba(0,0,0,.13)", overflow: "hidden",
        }}>
          <div style={{ padding: "8px 10px", borderBottom: "1px solid #F1F5F9" }}>
            <input
              autoFocus
              type="text"
              placeholder="Search area..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{
                width: "100%", height: 32, border: "1.5px solid #E2E8F0",
                borderRadius: 6, padding: "0 8px", fontSize: 12.5,
                fontFamily: "'Poppins', sans-serif", outline: "none",
                boxSizing: "border-box", color: "#1E293B",
              }}
            />
          </div>
          <div style={{ padding: "6px 12px", borderBottom: "1px solid #F1F5F9", display: "flex", gap: 10 }}>
            <button onClick={() => onChange(areas.map(a => a.areaId))} style={{ fontSize: 11.5, fontWeight: 700, color: BR, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "'Poppins', sans-serif" }}>Select All</button>
            <span style={{ color: "#E2E8F0", alignSelf: "center" }}>|</span>
            <button onClick={() => onChange([])} style={{ fontSize: 11.5, fontWeight: 700, color: "#991B1B", background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "'Poppins', sans-serif" }}>Clear</button>
          </div>
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            {filteredAreas.length === 0 ? (
              <div style={{ padding: "14px", fontSize: 12, color: "#94A3B8", textAlign: "center" }}>No areas found</div>
            ) : filteredAreas.map(a => {
              const checked = selectedIds.includes(a.areaId);
              return (
                <div
                  key={a.areaId}
                  onClick={() => toggle(a.areaId)}
                  style={{
                    display: "flex", alignItems: "center", gap: 9,
                    padding: "9px 12px", cursor: "pointer",
                    background: checked ? "#EFF6FF" : "transparent",
                    borderBottom: "1px solid #F8FAFC",
                  }}
                  onMouseEnter={e => { if (!checked) e.currentTarget.style.background = "#F8FAFC"; }}
                  onMouseLeave={e => { if (!checked) e.currentTarget.style.background = "transparent"; }}
                >
                  <span style={{
                    width: 16, height: 16, borderRadius: 4, flexShrink: 0,
                    border: `2px solid ${checked ? BR : "#CBD5E1"}`,
                    background: checked ? BR : "#fff",
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                  }}>
                    {checked && <span style={{ color: "#fff", fontSize: 10, fontWeight: 900, lineHeight: 1 }}>✓</span>}
                  </span>
                  <span style={{ fontSize: 13, color: checked ? BR : "#1E293B", fontWeight: checked ? 600 : 400, fontFamily: "'Poppins', sans-serif" }}>
                    {a.areaName}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Customer Detail Modal ──────────────────────────────────────────────────
function CustomerDetailModal({ followup, employeeMap, budgetMap, onClose }) {
  const customer     = followup?.enquiry?.customer || {};
  const statusName   = followup?.status?.statusName || "";
  const priorityName = followup?.priority?.priorityName || followup?.enquiry?.priority?.priorityName || "";
  const areaLabel    = (() => {
    const areas = followup?.enquiry?.areas;
    if (Array.isArray(areas) && areas.length > 0)
      return areas.map(a => a.areaName || a.name || "").filter(Boolean).join(", ");
    return null;
  })();

  const mediaName   = followup?.media?.communicationmediaName || null;
  const lastContact = followup?.callLeadDate ? new Date(followup.callLeadDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : null;

  const assignId = followup?.assignTo;
  const empInfo  = assignId ? employeeMap[assignId] : null;
  const empName  = empInfo?.name || (assignId ? `#${assignId}` : null);

  const historyRows = [followup].filter(Boolean);

  const formatDateTime = (d) => {
    if (!d) return { date: "—", time: "" };
    const dt = new Date(d);
    return {
      date: dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }),
      time: dt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true }),
    };
  };

  const handleBackdrop = (e) => { if (e.target === e.currentTarget) onClose(); };

  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  const InfoRow = ({ label, value, colorLeft = "#F97316" }) => (
    <div style={{ display: "flex", borderBottom: "1px solid #F1F5F9" }}>
      <div style={{ borderLeft: `3px solid ${colorLeft}`, padding: "12px 16px", minWidth: 140, fontSize: 13, fontWeight: 600, color: colorLeft, background: "#FAFAFA", flexShrink: 0 }}>
        {label}
      </div>
      <div style={{ padding: "12px 16px", fontSize: 13, color: "#1E293B", display: "flex", alignItems: "center", flex: 1 }}>
        {value}
      </div>
    </div>
  );

  const LEFT_COLORS = ["#F97316", "#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#6366F1"];

  return (
    <div
      onClick={handleBackdrop}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(15,23,42,0.55)",
        backdropFilter: "blur(3px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px",
        animation: "fadeIn .2s ease",
      }}
    >
      <div style={{
        background: "#fff", borderRadius: 16, width: "100%", maxWidth: 760,
        maxHeight: "92vh", overflowY: "auto",
        boxShadow: "0 24px 64px rgba(0,0,0,.22)",
        animation: "slideUp .25s cubic-bezier(0.34,1.56,0.64,1)",
        fontFamily: "'Poppins', sans-serif",
      }}>
        <div style={{
          display: "flex", alignItems: "center", gap: 14,
          padding: "16px 20px", borderBottom: "1px solid #F1F5F9",
          position: "sticky", top: 0, background: "#fff", zIndex: 10,
          borderRadius: "16px 16px 0 0",
        }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: "#EFF6FF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>👁️</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#1E293B", lineHeight: 1.2 }}>{customer.customerName || "—"}</div>
            <div style={{ fontSize: 11.5, color: "#94A3B8", marginTop: 1 }}>Communication History</div>
          </div>
          <button
            onClick={onClose}
            style={{ width: 34, height: 34, borderRadius: 8, background: "#F1F5F9", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, color: "#64748B", fontWeight: 700, flexShrink: 0, transition: "all .15s" }}
            onMouseEnter={e => { e.currentTarget.style.background = "#FEE2E2"; e.currentTarget.style.color = "#DC2626"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#F1F5F9"; e.currentTarget.style.color = "#64748B"; }}
          >✕</button>
        </div>

        <div style={{ margin: "16px 20px", borderRadius: 10, overflow: "hidden", border: "1px solid #F1F5F9", boxShadow: "0 1px 4px rgba(0,0,0,.05)" }}>
          <InfoRow colorLeft={LEFT_COLORS[0]} label="Customer" value={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Avatar name={customer.customerName} size={28} />
              <span style={{ fontWeight: 600 }}>{customer.customerName || "—"}</span>
            </div>
          } />
          <InfoRow colorLeft={LEFT_COLORS[1]} label="Mobile" value={<span style={{ fontWeight: 600, letterSpacing: "0.5px" }}>{customer.mobileno || "—"}</span>} />
          <InfoRow colorLeft={LEFT_COLORS[2]} label="Area" value={
            areaLabel
              ? <span style={{ background: "#FFF7ED", color: "#9A3412", padding: "2px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600 }}>📍 {areaLabel}</span>
              : <span style={{ color: "#CBD5E1" }}>—</span>
          } />
          <InfoRow colorLeft={LEFT_COLORS[3]} label="Communication" value={
            mediaName
              ? <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F0FDF4", border: "1px solid #BBF7D0", color: "#166534", padding: "3px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600 }}>📞 {mediaName}</span>
              : <span style={{ background: "#F1F5F9", border: "1px solid #E2E8F0", color: "#64748B", padding: "3px 10px", borderRadius: 6, fontSize: 12.5, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5 }}>📞 —</span>
          } />
          <InfoRow colorLeft={LEFT_COLORS[4]} label="Priority" value={<PriorityBadge priorityName={priorityName} />} />
          <InfoRow colorLeft={LEFT_COLORS[5]} label="Last Contact" value={
            lastContact
              ? <span style={{ fontWeight: 600, color: "#475569" }}>{lastContact}</span>
              : <span style={{ color: "#CBD5E1" }}>—</span>
          } />
          <InfoRow colorLeft="#6366F1" label="Status" value={<StatusBadge statusName={statusName} />} />
        </div>

        <div style={{ margin: "0 20px 20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 0 10px", borderTop: "2px solid #F1F5F9", marginBottom: 0 }}>
            <span style={{ fontSize: 14 }}>🕐</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase" }}>Communication History</span>
            <span style={{ background: "#EFF6FF", color: BR, borderRadius: 20, padding: "1px 9px", fontSize: 11.5, fontWeight: 700, marginLeft: 2 }}>{historyRows.length}</span>
          </div>
          <div style={{ borderRadius: 10, overflow: "hidden", border: "1px solid #F1F5F9", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 620 }}>
                <thead>
                  <tr style={{ background: "#F8FAFC", borderBottom: "2px solid #E2E8F0" }}>
                    {["#", "Date & Time", "Media", "Status", "Priority", "Assigned To", "Note", "Active"].map(h => (
                      <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase", whiteSpace: "nowrap", fontFamily: "'Poppins', sans-serif" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {historyRows.map((row, idx) => {
                    const rDt      = formatDateTime(row?.callLeadDate);
                    const rMedia   = row?.media?.communicationmediaName || null;
                    const rStatus  = row?.status?.statusName || "";
                    const rPri     = row?.priority?.priorityName || row?.enquiry?.priority?.priorityName || "";
                    const rAssign  = row?.assignTo ? employeeMap[row.assignTo] : null;
                    const rEmpName = rAssign?.name || (row?.assignTo ? `#${row.assignTo}` : null);
                    const rNote    = row?.followupRemark || null;
                    const isActive = row?.isActive !== 0;
                    return (
                      <tr key={idx} style={{ borderBottom: "1px solid #F8FAFC", background: "#fff" }}>
                        <td style={{ padding: "10px 12px", fontSize: 12.5, color: "#94A3B8", fontWeight: 600 }}>{idx + 1}</td>
                        <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1E293B" }}>{rDt.date}</div>
                          <div style={{ fontSize: 11, color: "#94A3B8" }}>{rDt.time}</div>
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          {rMedia ? <span style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", color: "#475569", padding: "2px 8px", borderRadius: 6, fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>📞 {rMedia}</span>
                            : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                        </td>
                        <td style={{ padding: "10px 12px" }}><StatusBadge statusName={rStatus} /></td>
                        <td style={{ padding: "10px 12px" }}><PriorityBadge priorityName={rPri} /></td>
                        <td style={{ padding: "10px 12px" }}>
                          {rEmpName ? (
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <Avatar name={rEmpName} size={24} />
                              <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1E293B" }}>{rEmpName}</span>
                            </div>
                          ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                        </td>
                        <td style={{ padding: "10px 12px", maxWidth: 160 }}>
                          {rNote ? <span title={rNote} style={{ fontSize: 12, color: "#475569", fontStyle: "italic", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>💬 {rNote}</span>
                            : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          <span style={{ background: isActive ? "#DCFCE7" : "#F1F5F9", color: isActive ? "#166534" : "#64748B", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                            {isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const formatDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const getAreaLabel = (enquiry) => {
  if (!enquiry) return null;
  const areas = enquiry.areas;
  if (Array.isArray(areas) && areas.length > 0)
    return areas.map(a => a.areaName || a.name || "").filter(Boolean).join(", ") || null;
  return null;
};

const getAreaIds = (enquiry) => {
  if (!enquiry?.areas) return [];
  return enquiry.areas.map(a => a.areaId).filter(Boolean);
};

const PER_PAGE = 10;

export default function FollowupReport() {
  const [allData, setAllData]             = useState([]);
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState(null);
  const [statusFilter, setStatusFilter]   = useState("All");
  const [callFilter, setCallFilter]       = useState("All");
  const [empFilter, setEmpFilter]         = useState("All");
  const [startDate, setStartDate]         = useState("");
  const [endDate, setEndDate]             = useState("");
  const [searchQuery, setSearchQuery]     = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [page, setPage]                   = useState(1);
  const [selectedFollowup, setSelectedFollowup] = useState(null);
  const [statsEmployee, setStatsEmployee] = useState(null);
  const [exporting, setExporting]         = useState(false);
  const navigate = useNavigate();

  const [employeeMap, setEmployeeMap] = useState({});
  const [budgetMap, setBudgetMap]     = useState({});
  const [areaList, setAreaList]       = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const [logoBase64, setLogoBase64] = useState("");

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width  = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      try { setLogoBase64(canvas.toDataURL("image/png")); } catch (_) {}
    };
    img.onerror = () => {};
    img.src = crmLogo;
  }, []);

  const fetchAreas = useCallback(async () => {
    try {
      const filter = JSON.stringify({ where: { isActive: 1 }, order: ["areaName ASC"] });
      const res = await fetch(`${AREA_API_URL}?filter=${encodeURIComponent(filter)}`);
      if (!res.ok) return;
      const ct = res.headers.get("content-type");
      if (!ct?.includes("application/json")) return;
      const json = await res.json();
      if (!Array.isArray(json)) return;
      setAreaList(json.map(a => ({ areaId: a.areaId ?? a.id, areaName: a.areaName ?? a.name ?? `Area #${a.areaId ?? a.id}` })));
    } catch (_) {}
  }, []);

  const fetchBudgets = useCallback(async () => {
    try {
      const res = await fetch(`${BUDGET_API_URL}?filter=${encodeURIComponent(JSON.stringify({ where: { isActive: 1 } }))}`);
      if (!res.ok) return;
      const ct = res.headers.get("content-type");
      if (!ct?.includes("application/json")) return;
      const json = await res.json();
      if (!Array.isArray(json)) return;
      const map = {};
      json.forEach((b) => {
        const id = b.budgetId ?? b.id;
        if (id == null) return;
        const label = b.budgetName ?? b.budgetRange ?? b.budgetLabel ?? b.name ?? b.label ?? null;
        const min   = b.minAmount ?? b.minBudget ?? b.min ?? b.budgetMin ?? null;
        const max   = b.maxAmount ?? b.maxBudget ?? b.max ?? b.budgetMax ?? null;
        map[id] = { label, min, max };
      });
      setBudgetMap(map);
    } catch (_) {}
  }, []);

  const fetchEmployees = useCallback(async () => {
    try {
      const filter = JSON.stringify({ where: { isActive: 1 } });
      const res = await fetch(`${EMP_API_URL}?filter=${encodeURIComponent(filter)}`);
      if (!res.ok) return;
      const ct = res.headers.get("content-type");
      if (!ct?.includes("application/json")) return;
      const json = await res.json();
      if (!Array.isArray(json)) return;
      const map = {};
      const list = [];
      json.forEach((emp) => {
        const id    = emp.employeeId ?? emp.id;
        const name  = emp.employeeName ?? emp.name ?? `Emp #${id}`;
        const desig = emp.designation ?? emp.designationName ?? "";
        if (id != null) {
          map[id] = { name, desig };
          list.push({ id, name, desig });
        }
      });
      setEmployeeMap(map);
      setEmployeeList(list);
    } catch (_) {}
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const filter = JSON.stringify({ order: ["followupId DESC"] });
      const res = await fetch(`${API_URL}?filter=${encodeURIComponent(filter)}`);
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const ct = res.headers.get("content-type");
      if (!ct?.includes("application/json"))
        throw new Error(`Expected JSON but got HTML — check API URL: ${API_URL}`);
      const json = await res.json();
      setAllData(Array.isArray(json) ? json : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchEmployees();
    fetchBudgets();
    fetchAreas();
  }, [fetchData, fetchEmployees, fetchBudgets, fetchAreas]);

  const getBudgetDisplay = (fkBudgetId) => {
    if (!fkBudgetId) return null;
    const b = budgetMap[fkBudgetId];
    if (!b) return null;
    if (b.label) return b.label;
    if (b.min != null && b.max != null)
      return `₹${Number(b.min).toLocaleString("en-IN")} – ₹${Number(b.max).toLocaleString("en-IN")}`;
    if (b.min != null) return `₹${Number(b.min).toLocaleString("en-IN")}+`;
    if (b.max != null) return `Up to ₹${Number(b.max).toLocaleString("en-IN")}`;
    return `Budget #${fkBudgetId}`;
  };

  const empListFromData = React.useMemo(() => {
    const seen = new Set();
    const result = [];
    allData.forEach(f => {
      const id = f.assignTo;
      if (id != null && !seen.has(id)) {
        seen.add(id);
        const info = employeeMap[id];
        result.push({ id, name: info?.name || `Employee #${id}` });
      }
    });
    result.sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }, [allData, employeeMap]);

  // ── Filtered data ──────────────────────────────────────────────────────────
  const filtered = allData.filter((f) => {
    const statusName = f.status?.statusName || "";
    const sn = statusName.toLowerCase();

    if (statusFilter === "Follow Up"     && !sn.includes("follow"))  return false;
    if (statusFilter === "Success Close" && !sn.includes("success")) return false;
    if (statusFilter === "Cancel"        && !sn.includes("cancel"))  return false;

    if (callFilter === "called"    && f.isActive !== 0) return false;
    if (callFilter === "notcalled" && f.isActive !== 1) return false;

    if (empFilter !== "All" && String(f.assignTo) !== String(empFilter)) return false;

    if (selectedAreas.length > 0) {
      const rowAreaIds = getAreaIds(f.enquiry);
      if (!rowAreaIds.some(id => selectedAreas.includes(id))) return false;
    }

    if (startDate || endDate) {
      const d = f.callLeadDate ? new Date(f.callLeadDate) : null;
      if (!d) return false;
      if (startDate && d < new Date(startDate))             return false;
      if (endDate   && d > new Date(endDate + "T23:59:59")) return false;
    }

    if (searchQuery.trim()) {
      const q            = searchQuery.trim().toLowerCase();
      const customer     = f.enquiry?.customer || {};
      const empName      = (employeeMap[f.assignTo]?.name || "").toLowerCase();
      const areaLabel    = (getAreaLabel(f.enquiry) || "").toLowerCase();
      const customerName = (customer.customerName || "").toLowerCase();
      const mobile       = (customer.mobileno || "").toLowerCase();
      const enquiryId    = String(f.fkenquiryId || "");
      const followupId   = String(f.followupId  || "");
      const note         = (f.followupRemark || "").toLowerCase();

      if (
        !customerName.includes(q) && !mobile.includes(q) &&
        !enquiryId.includes(q)    && !followupId.includes(q) &&
        !empName.includes(q)      && !areaLabel.includes(q) &&
        !note.includes(q)
      ) return false;
    }

    return true;
  });

  useEffect(() => { setPage(1); }, [statusFilter, callFilter, empFilter, startDate, endDate, searchQuery, selectedAreas]);

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated  = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const statsTotal   = filtered.length;
  const statsFollow  = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("follow")).length;
  const statsSuccess = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("success")).length;
  const statsCancel  = filtered.filter(f => (f.status?.statusName||"").toLowerCase().includes("cancel")).length;

  const empStatsData = React.useMemo(() => {
    if (empFilter === "All") return null;
    const empId = Number(empFilter);
    const empRecords = allData.filter(f => f.assignTo === empId || f.assignTo === empFilter);
    const called    = empRecords.filter(f => f.isActive === 0).length;
    const notCalled = empRecords.filter(f => f.isActive === 1).length;
    const total     = empRecords.length;
    const empName   = employeeMap[empId]?.name || `Employee #${empId}`;
    return { empId, empName, called, notCalled, total };
  }, [empFilter, allData, employeeMap]);

  const clearFilters = () => {
    setStatusFilter("All"); setCallFilter("All"); setEmpFilter("All");
    setStartDate(""); setEndDate(""); setSearchQuery(""); setSelectedAreas([]);
  };
  const isFiltered = statusFilter !== "All" || callFilter !== "All" || empFilter !== "All" || startDate || endDate || searchQuery.trim() || selectedAreas.length > 0;

  // ── Print Handler ─────────────────────────────────────────────────────────
  const handlePrint = () => {
    const customer_rows = filtered.map((f, idx) => {
      const customer      = f.enquiry?.customer || {};
      const statusName    = f.status?.statusName || "New";
      const priorityName  = f.priority?.priorityName || f.enquiry?.priority?.priorityName || "—";
      const mediaName     = f.media?.communicationmediaName || "—";
      const areaLabel     = getAreaLabel(f.enquiry) || "—";
      const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId) || "—";
      const empInfo       = f.assignTo ? employeeMap[f.assignTo] : null;
      const empName       = empInfo?.name || (f.assignTo ? `#${f.assignTo}` : "—");
      const empDesig      = empInfo?.desig || "—";
      const callDt        = f.callLeadDate ? new Date(f.callLeadDate) : null;
      const dateStr       = callDt ? callDt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
      const callStatus    = f.isActive === 0 ? "Called" : "Not Called";
      const callStatusColor = f.isActive === 0 ? "#166534" : "#854D0E";

      const sn = statusName.toLowerCase();
      const statusColor = sn.includes("follow") ? "#854D0E"
        : sn.includes("success") ? "#166534"
        : sn.includes("cancel")  ? "#991B1B"
        : "#6D28D9";

      return `
        <tr style="background:${idx % 2 === 1 ? "#F8FAFC" : "#fff"}">
          <td>${idx + 1}</td>
          <td>${customer.customerName || "—"}</td>
          <td>${customer.mobileno || "—"}</td>
          <td>${dateStr}</td>
          <td>${mediaName}</td>
          <td>${areaLabel}</td>
          <td>${budgetDisplay}</td>
          <td style="color:${statusColor};font-weight:700">${statusName}</td>
          <td>${priorityName}</td>
          <td>${empName}</td>
          <td>${empDesig}</td>
          <td style="color:${callStatusColor};font-weight:700">${callStatus}</td>
          <td style="max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${f.followupRemark || "—"}</td>
        </tr>`;
    }).join("");

    const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    const logoImgTag = logoBase64
      ? `<img class="print-logo" src="${logoBase64}" alt="Logo" />`
      : `<img class="print-logo" src="${crmLogo}" alt="Logo" />`;

    const printHtml = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Follow-up Report</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Poppins', sans-serif; background: #fff; padding: 24px 28px; color: #1E293B; font-size: 9px; }
    .print-header { display: flex; flex-direction: column; align-items: center; margin-bottom: 12px; }
    .print-logo { width: 64px; height: 64px; object-fit: contain; margin-bottom: 6px; }
    .print-company-name { font-size: 17px; font-weight: 800; color: #0d1b3e; text-align: center; margin-bottom: 8px; }
    .print-divider { width: 100%; height: 2px; background: #0d1b3e; margin-bottom: 8px; }
    .print-report-title { font-size: 13px; font-weight: 700; color: #1D4ED8; text-align: center; text-decoration: underline; text-underline-offset: 4px; margin-bottom: 14px; letter-spacing: 0.5px; }
    table { width: 100%; border-collapse: collapse; font-size: 8.5px; page-break-inside: auto; }
    thead { display: table-header-group; }
    tr { page-break-inside: avoid; }
    th { background: #0d1b3e !important; color: #ffffff !important; padding: 7px 8px; text-align: left; font-size: 8px; font-weight: 700; letter-spacing: 0.4px; text-transform: uppercase; border: 1px solid #0d1b3e; white-space: nowrap; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    td { padding: 6px 8px; border: 1px solid #D1D5DB; font-size: 8.5px; color: #1E293B; vertical-align: middle; line-height: 1.4; }
    .print-footer { margin-top: 12px; display: flex; justify-content: space-between; align-items: center; font-size: 8.5px; color: #64748B; border-top: 1px solid #E2E8F0; padding-top: 8px; }
    @media print { body { padding: 12px 16px; } th { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; } }
  </style>
</head>
<body>
  <div class="print-header">
    ${logoImgTag}
    <p class="print-company-name">वरदविनायक रिअल इन्फ्रा प्रा. लि.</p>
    <div class="print-divider"></div>
    <p class="print-report-title">Follow-up Report</p>
  </div>
  <table>
    <thead>
      <tr>
        <th>#</th><th>Customer Name</th><th>Mobile</th><th>Followup Date</th>
        <th>Media</th><th>Area</th><th>Budget</th><th>Lead Status</th>
        <th>Priority</th><th>Assigned To</th><th>Designation</th>
        <th>Call Status</th><th>Note / Remark</th>
      </tr>
    </thead>
    <tbody>${customer_rows}</tbody>
  </table>
  <div class="print-footer">
    <span>वरदविनायक रिअल इन्फ्रा प्रा. लि. — Confidential</span>
    <span>Printed on: ${today} &nbsp;|&nbsp; Total Records: ${filtered.length}</span>
  </div>
  <script>window.onload=function(){window.print();setTimeout(function(){window.close();},500);};<\/script>
</body></html>`;

    const printWindow = window.open("", "_blank", "width=1200,height=800");
    if (!printWindow) { alert("Popup blocked! Please allow popups for this site and try again."); return; }
    printWindow.document.open();
    printWindow.document.write(printHtml);
    printWindow.document.close();
  };

  // ── Excel Export ──────────────────────────────────────────────────────────
  const exportToExcel = () => {
    if (filtered.length === 0) return;
    setExporting(true);
    try {
      const rows = filtered.map((f, idx) => {
        const customer      = f.enquiry?.customer || {};
        const statusName    = f.status?.statusName || "New";
        const priorityName  = f.priority?.priorityName || f.enquiry?.priority?.priorityName || "—";
        const mediaName     = f.media?.communicationmediaName || "—";
        const areaLabel     = getAreaLabel(f.enquiry) || "—";
        const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId) || "—";
        const empInfo       = f.assignTo ? employeeMap[f.assignTo] : null;
        const empName       = empInfo?.name || (f.assignTo ? `#${f.assignTo}` : "—");
        const empDesig      = empInfo?.desig || "—";
        const callDt        = f.callLeadDate ? new Date(f.callLeadDate) : null;
        const callStatus    = f.isActive === 0 ? "Called" : "Not Called";

        return {
          "Sr No":           idx + 1,
          "Followup ID":     f.followupId || "—",
          "Enquiry ID":      f.fkenquiryId || "—",
          "Followup Date":   callDt ? callDt.toLocaleDateString("en-IN") : "—",
          "Followup Time":   callDt ? callDt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true }) : "—",
          "Customer Name":   customer.customerName || "—",
          "Mobile":          customer.mobileno || "—",
          "Email":           customer.emailid || "—",
          "City":            customer.city || "—",
          "Area":            areaLabel,
          "Budget":          budgetDisplay,
          "Communication":   mediaName,
          "Lead Status":     statusName,
          "Priority":        priorityName,
          "Assigned To":     empName,
          "Designation":     empDesig,
          "Call Status":     callStatus,
          "Remark / Note":   f.followupRemark || "—",
        };
      });

      const ws1 = XLSX.utils.json_to_sheet(rows);
      ws1["!cols"] = [
        { wch: 6 }, { wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 12 },
        { wch: 24 }, { wch: 14 }, { wch: 26 }, { wch: 14 }, { wch: 24 },
        { wch: 18 }, { wch: 16 }, { wch: 18 }, { wch: 12 }, { wch: 20 },
        { wch: 18 }, { wch: 14 }, { wch: 34 },
      ];

      const range1 = XLSX.utils.decode_range(ws1["!ref"]);
      for (let C = range1.s.c; C <= range1.e.c; C++) {
        const cellAddr = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!ws1[cellAddr]) continue;
        ws1[cellAddr].s = {
          font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
          fill: { fgColor: { rgb: "072877" } },
          alignment: { horizontal: "center", vertical: "center", wrapText: true },
        };
      }

      const today = new Date().toLocaleDateString("en-IN");
      const summaryData = [
        { "Summary": "Total Follow-ups",   "Count": statsTotal   },
        { "Summary": "Follow Up",          "Count": statsFollow  },
        { "Summary": "Success Close",      "Count": statsSuccess },
        { "Summary": "Cancelled",          "Count": statsCancel  },
        { "Summary": "Call Filter",        "Count": callFilter === "All" ? "All" : callFilter === "called" ? "Called" : "Not Called" },
        { "Summary": "Employee Filter",    "Count": empFilter === "All" ? "All" : (employeeMap[empFilter]?.name || `#${empFilter}`) },
        { "Summary": "Export Date",        "Count": today        },
        { "Summary": "Filters Applied",    "Count": isFiltered ? "Yes" : "No" },
        { "Summary": "Status Filter",      "Count": statusFilter },
        { "Summary": "Date Range",         "Count": startDate && endDate ? `${startDate} to ${endDate}` : startDate ? `From ${startDate}` : endDate ? `To ${endDate}` : "All" },
        { "Summary": "Areas Selected",     "Count": selectedAreas.length > 0 ? selectedAreas.map(id => areaList.find(a => a.areaId === id)?.areaName || id).join(", ") : "All" },
      ];
      const ws2 = XLSX.utils.json_to_sheet(summaryData);
      ws2["!cols"] = [{ wch: 22 }, { wch: 34 }];

      const range2 = XLSX.utils.decode_range(ws2["!ref"]);
      for (let C = range2.s.c; C <= range2.e.c; C++) {
        const cellAddr = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!ws2[cellAddr]) continue;
        ws2[cellAddr].s = {
          font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
          fill: { fgColor: { rgb: "1D4ED8" } },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws1, "Followup Report");
      XLSX.utils.book_append_sheet(wb, ws2, "Summary");

      const fileName = `Followup_Report_${today.replace(/\//g, "-")}.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (err) {
      console.error("Export error:", err);
      alert("Export failed: " + err.message);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div style={{ width: "100%", minHeight: "100vh", background: "#F1F5F9", fontFamily: "'Poppins', sans-serif", paddingBottom: 40 }}>
      <style>{`
        @keyframes shimmer  { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
        @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
        @keyframes slideUp  { from{opacity:0;transform:translateY(24px) scale(.98)} to{opacity:1;transform:translateY(0) scale(1)} }
        .rpt-row { transition: background .15s; cursor: pointer; }
        .rpt-row:hover { background: #EFF6FF !important; }
        .date-input { height: 40px; border: 1.5px solid #E2E8F0; border-radius: 8px; padding: 0 12px; font-size: 13px; font-family: 'Poppins', sans-serif; color: #1E293B; outline: none; background: #fff; cursor: pointer; }
        .date-input:focus { border-color: #1D4ED8; }
        .search-input { height: 42px; border: 1.5px solid #E2E8F0; border-radius: 8px; padding: 0 34px 0 36px; font-size: 13.5px; font-family: 'Poppins', sans-serif; color: #1E293B; outline: none; background: #fff; min-width: 220px; transition: border-color .15s; }
        .search-input:focus { border-color: #1D4ED8; box-shadow: 0 0 0 3px rgba(29,78,216,.08); }
        .search-input::placeholder { color: #94A3B8; }
        .page-btn { padding: 6px 14px; border-radius: 6px; border: 1.5px solid #E2E8F0; background: #fff; cursor: pointer; font-size: 13px; font-weight: 600; color: #1D4ED8; font-family: 'Poppins', sans-serif; transition: all .15s; }
        .page-btn:disabled { color: #CBD5E1; cursor: not-allowed; background: #F8FAFC; }
        .page-btn.curr { background: #1D4ED8; color: #fff; border-color: #1D4ED8; }
        .flt-select { height: 42px; border: 1.5px solid #E2E8F0; border-radius: 8px; padding: 0 36px 0 14px; font-size: 13.5px; font-family: 'Poppins', sans-serif; color: #1E293B; outline: none; background: #fff; cursor: pointer; appearance: none; -webkit-appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 12px center; font-weight: 500; }
        .flt-select:focus { border-color: #1D4ED8; }
        .icon-btn { width: 38px; height: 38px; border-radius: 10px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 18px; transition: all .2s; position: relative; flex-shrink: 0; }
        .icon-btn:active { transform: scale(0.92); }
        .print-icon-btn { background: linear-gradient(135deg, #fa0505, #720202); box-shadow: 0 2px 8px rgba(220,38,38,0.40); }
        .print-icon-btn:hover { background: linear-gradient(135deg, #DC2626, #B91C1C); box-shadow: 0 4px 14px rgba(220,38,38,0.52); transform: translateY(-2px); }
        .excel-icon-btn { background: linear-gradient(135deg, #099443, #039c3b); box-shadow: 0 2px 8px rgba(22,163,74,0.40); }
        .excel-icon-btn:hover { background: linear-gradient(135deg, #16A34A, #15803D); box-shadow: 0 4px 14px rgba(22,163,74,0.52); transform: translateY(-2px); }
        .excel-icon-btn:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }
        .icon-btn-wrap { position: relative; display: inline-flex; }
        .icon-btn-wrap .tooltip { position: absolute; bottom: calc(100% + 7px); left: 50%; transform: translateX(-50%); background: rgba(15,23,42,0.88); color: #fff; font-size: 11px; font-weight: 600; white-space: nowrap; padding: 4px 9px; border-radius: 6px; pointer-events: none; opacity: 0; transition: opacity .18s; font-family: 'Poppins', sans-serif; }
        .icon-btn-wrap:hover .tooltip { opacity: 1; }
        .emp-stats-row { cursor: pointer; transition: background .15s; }
        .emp-stats-row:hover { background: #F0FDF4 !important; }
      `}</style>

      {/* ── Header ─────────────────────────────────────────────────────── */}
      <div style={{
        background: "#0d1b3e",
        backgroundImage: `repeating-linear-gradient(0deg,transparent,transparent 39px,rgba(255,255,255,0.018) 39px,rgba(255,255,255,0.018) 40px),
          repeating-linear-gradient(90deg,transparent,transparent 39px,rgba(255,255,255,0.018) 39px,rgba(255,255,255,0.018) 40px)`,
        padding: "0 28px", display: "flex", alignItems: "center",
        justifyContent: "space-between", flexWrap: "wrap", gap: 16, minHeight: 76,
      }}>
        <div style={{ padding: "14px 0" }}>
          <div style={{ fontSize: 9.5, fontWeight: 600, letterSpacing: "2px", textTransform: "uppercase", color: "rgba(148,163,184,0.65)", marginBottom: 3 }}>LEAD MANAGEMENT</div>
          <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>📊 Follow-up Report</div>
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          {!loading && !error && filtered.length > 0 && (
            <div className="icon-btn-wrap">
              <button className="icon-btn print-icon-btn" onClick={handlePrint} title="Print">🖨️</button>
              <span className="tooltip">Print ({filtered.length})</span>
            </div>
          )}
          {!loading && !error && filtered.length > 0 && (
            <div className="icon-btn-wrap">
              <button className="icon-btn excel-icon-btn" onClick={exportToExcel} disabled={exporting} title="Export Excel">
                {exporting ? "⏳" : "📥"}
              </button>
              <span className="tooltip">{exporting ? "Exporting…" : `Export Excel (${filtered.length})`}</span>
            </div>
          )}
          <button
            onClick={() => { fetchData(); fetchEmployees(); fetchBudgets(); fetchAreas(); }}
            style={{ background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.2)", color: "#fff", padding: "8px 18px", borderRadius: 50, fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "'Poppins', sans-serif", display: "flex", alignItems: "center", gap: 6 }}
          >🔄 Refresh</button>
        </div>
      </div>

      <div style={{ padding: "18px 16px" }}>

        {/* Filter Bar */}
        <div style={{ background: "#fff", borderRadius: 12, padding: "14px 18px", marginBottom: 12, display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end", boxShadow: "0 1px 6px rgba(7,40,119,.07)" }}>

          {/* Lead Status */}
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Lead Status</label>
            <select
              className="flt-select"
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
              style={{ borderColor: statusFilter !== "All" ? BR : "#E2E8F0", color: statusFilter !== "All" ? BR : "#1E293B", fontWeight: statusFilter !== "All" ? 700 : 500, minWidth: 180 }}
            >
              <option value="All">All Statuses</option>
              <option value="Follow Up">🔁 Follow Up</option>
              <option value="Success Close">✅ Success Close</option>
              <option value="Cancel">❌ Cancel</option>
            </select>
          </div>

          {/* Call Status Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Call Status</label>
            <select
              className="flt-select"
              value={callFilter}
              onChange={e => setCallFilter(e.target.value)}
              style={{
                borderColor: callFilter !== "All"
                  ? (callFilter === "called" ? "#166534" : "#854D0E")
                  : "#E2E8F0",
                color: callFilter !== "All"
                  ? (callFilter === "called" ? "#166534" : "#854D0E")
                  : "#1E293B",
                fontWeight: callFilter !== "All" ? 700 : 500,
                minWidth: 160,
              }}
            >
              <option value="All">📞 All Calls</option>
              <option value="called">✅ Called</option>
              <option value="notcalled">⏳ Not Called</option>
            </select>
          </div>

          {/* Employee Filter */}
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Employee</label>
            <select
              className="flt-select"
              value={empFilter}
              onChange={e => setEmpFilter(e.target.value)}
              style={{
                borderColor: empFilter !== "All" ? "#7C3AED" : "#E2E8F0",
                color: empFilter !== "All" ? "#7C3AED" : "#1E293B",
                fontWeight: empFilter !== "All" ? 700 : 500,
                minWidth: 190,
              }}
            >
              <option value="All">👤 All Employees</option>
              {empListFromData.map(e => (
                <option key={e.id} value={e.id}>👤 {e.name}</option>
              ))}
            </select>
          </div>

          <AreaMultiSelect areas={areaList} selectedIds={selectedAreas} onChange={setSelectedAreas} />

          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Start Date</label>
            <input type="date" className="date-input" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ borderColor: startDate ? BR : "#E2E8F0" }} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>End Date</label>
            <input type="date" className="date-input" value={endDate} onChange={e => setEndDate(e.target.value)} min={startDate || undefined} style={{ borderColor: endDate ? BR : "#E2E8F0" }} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#374151", letterSpacing: "0.5px", textTransform: "uppercase" }}>Search</label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", fontSize: 15, color: "#94A3B8", pointerEvents: "none" }}>🔍</span>
              <input type="text" className="search-input" placeholder="Name, mobile, note…" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{ borderColor: searchQuery.trim() ? BR : "#E2E8F0" }} />
              {searchQuery && (
                <button onClick={() => setSearchQuery("")} style={{ position: "absolute", right: 8, background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#94A3B8", padding: 0 }}>✕</button>
              )}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label style={{ fontSize: 11, color: "transparent" }}>x</label>
            <div className="icon-btn-wrap">
              <button
                className="icon-btn"
                // onClick={() => navigate("/followup-analytics")}
                style={{
                  background: "linear-gradient(135deg, #7C3AED, #5B21B6)",
                  boxShadow: "0 2px 8px rgba(124,58,237,0.40)",
                  width: 42,
                  height: 42,
                }}
                title="Analytics"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2a10 10 0 0 1 10 10h-10z" fill="#fff" opacity="0.95"/>
                  <path d="M12 12L4.93 17.07A10 10 0 0 1 2 12z" fill="#fff" opacity="0.65"/>
                  <path d="M12 12v-10a10 10 0 0 0-7.07 17.07z" fill="#fff" opacity="0.80"/>
                  <circle cx="12" cy="12" r="2.5" fill="#7C3AED"/>
                </svg>
              </button>
              <span className="tooltip">📊 Analytics</span>
            </div>
          </div>


          {isFiltered && (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <label style={{ fontSize: 11, color: "transparent" }}>x</label>
              <button onClick={clearFilters} style={{ height: 42, padding: "0 16px", borderRadius: 8, border: "1.5px solid #FECACA", background: "#FEF2F2", color: "#991B1B", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "'Poppins', sans-serif" }}>✕ Clear</button>
            </div>
          )}

          <div style={{ marginLeft: "auto", fontSize: 13, color: "#64748B", fontWeight: 600, alignSelf: "flex-end", paddingBottom: 4 }}>
            {filtered.length} record{filtered.length !== 1 ? "s" : ""}
          </div>
        </div>

        {/* Area chips */}
        {selectedAreas.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
            {selectedAreas.map(id => {
              const a = areaList.find(x => x.areaId === id);
              return (
                <span key={id} style={{ background: "#EFF6FF", color: BR, border: "1px solid #BFDBFE", borderRadius: 20, padding: "3px 10px", fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5, fontFamily: "'Poppins', sans-serif" }}>
                  📍 {a?.areaName || id}
                  <button onClick={() => setSelectedAreas(selectedAreas.filter(x => x !== id))} style={{ background: "none", border: "none", cursor: "pointer", color: BR, fontSize: 12, padding: 0, lineHeight: 1, fontWeight: 700 }}>✕</button>
                </span>
              );
            })}
          </div>
        )}

        {/* Stat Cards */}
        {!loading && !error && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 10, marginBottom: 16 }}>
            {[
              { label: "Total",         value: statsTotal,   bg: "#EFF6FF", color: BR,        icon: "📋" },
              { label: "Follow Up",     value: statsFollow,  bg: "#FEF9C3", color: "#854D0E", icon: "🔁" },
              { label: "Success Close", value: statsSuccess, bg: "#DCFCE7", color: "#166534", icon: "✅" },
              { label: "Cancelled",     value: statsCancel,  bg: "#FEE2E2", color: "#991B1B", icon: "❌" },
            ].map((c, i) => (
              <div key={i} style={{ background: c.bg, borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, boxShadow: "0 1px 4px rgba(0,0,0,.05)" }}>
                <span style={{ fontSize: 22 }}>{c.icon}</span>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: c.color, lineHeight: 1.1 }}>{c.value}</div>
                  <div style={{ fontSize: 11.5, color: "#64748B", fontWeight: 600 }}>{c.label}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Loading */}
        {loading && (
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 6px rgba(7,40,119,.06)" }}>
            {[...Array(7)].map((_, i) => (
              <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
                <Skeleton width={36} height={36} radius={50} />
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                  <Skeleton width="35%" height={13} />
                  <Skeleton width="55%" height={11} />
                </div>
                <Skeleton width={90} height={24} radius={20} />
                <Skeleton width={70} height={24} radius={20} />
              </div>
            ))}
          </div>
        )}

        {/* Error */}
        {error && !loading && (
          <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 12, padding: "24px", textAlign: "center", color: "#991B1B" }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>⚠️</div>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>API Error</div>
            <div style={{ fontSize: 13, opacity: .8, marginBottom: 14 }}>{error}</div>
            <button onClick={fetchData} style={{ padding: "8px 22px", borderRadius: 50, background: "#DC2626", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer", fontFamily: "'Poppins', sans-serif" }}>🔄 Retry</button>
          </div>
        )}

        {/* Table */}
        {!loading && !error && (
          <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(7,40,119,.07)", overflow: "hidden", animation: "fadeIn .3s ease" }}>
            {paginated.length === 0 ? (
              <div style={{ padding: 52, textAlign: "center", color: "#94A3B8" }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>🔍</div>
                <div style={{ fontWeight: 700, fontSize: 16, color: "#64748B" }}>No records found</div>
                <div style={{ fontSize: 13, marginTop: 4 }}>Try changing the filters or search query</div>
              </div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 860 }}>
                  <thead>
                    <tr style={{ background: "#F8FAFC", borderBottom: "2px solid #E2E8F0" }}>
                      {["#", "Customer", "Follow-up Date", "Media", "Budget", "Area", "Lead Status", "Note", "Assigned To"].map(h => (
                        <th key={h} style={{ padding: "11px 12px", textAlign: "left", fontSize: 11.5, fontWeight: 700, color: "#64748B", letterSpacing: "0.5px", textTransform: "uppercase", whiteSpace: "nowrap", fontFamily: "'Poppins', sans-serif" }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginated.map((f, idx) => {
                      const srNo          = (page - 1) * PER_PAGE + idx + 1;
                      const customer      = f.enquiry?.customer || {};
                      const statusName    = f.status?.statusName || (f.fkLeadStatusId === 0 ? "New" : "");
                      const mediaName     = f.media?.communicationmediaName || "—";
                      const assignId      = f.assignTo;
                      const areaLabel     = getAreaLabel(f.enquiry);
                      const budgetDisplay = getBudgetDisplay(f.enquiry?.fkBudgetId);
                      const empInfo       = assignId ? employeeMap[assignId] : null;
                      const empName       = empInfo?.name  || (assignId ? `#${assignId}` : null);
                      const empDesig      = empInfo?.desig || "";
                      const note          = f.followupRemark || null;

                      return (
                        <tr
                          key={f.followupId}
                          className="rpt-row"
                          style={{ borderBottom: "1px solid #F1F5F9" }}
                          onClick={() => setSelectedFollowup(f)}
                          title="Click to view details"
                        >
                          <td style={{ padding: "10px 12px", fontSize: 12.5, color: "#94A3B8", fontWeight: 600 }}>{srNo}</td>
                          <td style={{ padding: "10px 12px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <Avatar name={customer.customerName} size={30} />
                              <div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: "#1E293B" }}>{customer.customerName || "—"}</div>
                                <div style={{ fontSize: 11, color: "#94A3B8" }}>{customer.mobileno || ""}</div>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "10px 12px", fontSize: 13, color: "#475569", whiteSpace: "nowrap" }}>{formatDate(f.callLeadDate)}</td>
                          <td style={{ padding: "10px 12px" }}>
                            {mediaName !== "—"
                              ? <span style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", color: "#475569", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 600 }}>{mediaName}</span>
                              : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            {budgetDisplay
                              ? <span style={{ background: "#F0FDF4", color: "#166534", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap" }}>{budgetDisplay}</span>
                              : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            {areaLabel
                              ? <span style={{ background: "#FFF7ED", color: "#9A3412", padding: "2px 9px", borderRadius: 6, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>📍 {areaLabel}</span>
                              : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                          </td>
                          <td style={{ padding: "10px 12px" }}><StatusBadge statusName={statusName} /></td>
                          <td style={{ padding: "10px 12px", maxWidth: 190 }}>
                            {note ? (
                              <span title={note} style={{ display: "block", fontSize: 12.5, color: "#475569", fontStyle: "italic", lineHeight: 1.4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
                                💬 {note}
                              </span>
                            ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            {empName ? (
                              <div
                                onClick={e => {
                                  e.stopPropagation();
                                  setStatsEmployee({ empId: assignId, empName, ...(() => {
                                    const recs = allData.filter(r => r.assignTo === assignId || r.assignTo === Number(assignId));
                                    return {
                                      called:    recs.filter(r => r.isActive === 0).length,
                                      notCalled: recs.filter(r => r.isActive === 1).length,
                                      total:     recs.length,
                                    };
                                  })() });
                                }}
                                title={`Click to see ${empName}'s call stats`}
                                className="emp-stats-row"
                                style={{ display: "flex", alignItems: "center", gap: 7, padding: "3px 6px", borderRadius: 6, cursor: "pointer" }}
                              >
                                <Avatar name={empName} size={26} />
                                <div>
                                  <div style={{ fontWeight: 700, fontSize: 12.5, color: "#1E293B", lineHeight: 1.2 }}>{empName}</div>
                                  {empDesig && <div style={{ fontSize: 10.5, color: "#94A3B8", fontWeight: 500 }}>{empDesig}</div>}
                                </div>
                                <span style={{ fontSize: 10, color: "#7C3AED", fontWeight: 700, marginLeft: 2 }}>📊</span>
                              </div>
                            ) : <span style={{ color: "#CBD5E1", fontSize: 12 }}>—</span>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{ borderTop: "1px solid #F1F5F9", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <span style={{ fontSize: 13, color: "#64748B" }}>
                  Showing {(page - 1) * PER_PAGE + 1}–{Math.min(page * PER_PAGE, filtered.length)} of {filtered.length}
                </span>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="page-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>← Prev</button>
                  {[...Array(totalPages)].map((_, i) =>
                    Math.abs(page - (i + 1)) <= 2 && (
                      <button key={i} className={`page-btn${page === i + 1 ? " curr" : ""}`} onClick={() => setPage(i + 1)}>{i + 1}</button>
                    )
                  )}
                  <button className="page-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>Next →</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Customer Detail Modal */}
      {selectedFollowup && (
        <CustomerDetailModal
          followup={selectedFollowup}
          employeeMap={employeeMap}
          budgetMap={budgetMap}
          onClose={() => setSelectedFollowup(null)}
        />
      )}

      {/* Employee Stats Modal */}
      {statsEmployee && (
        <EmployeeStatsModal
          employeeId={statsEmployee.empId}
          employeeName={statsEmployee.empName}
          allData={allData}
          onClose={() => setStatsEmployee(null)}
        />
      )}
    </div>
  );
}













